export const translation = {
  common: {
    logout: 'Odjava',
    account: 'Nalog',
    myAccount: 'Moj nalog',
    search: 'Pretraži...',
    actions: 'Akcije',
    view: 'Pregledaj',
    details: 'Detalji',
    edit: 'Izmeni',
    delete: 'Obriši',
    save: 'Sačuvaj',
    saving: 'Čuvanje...',
    deleting: 'Brisanje...',
    cancel: 'Odustani',
    close: 'Zatvori',
    back: 'Nazad',
    backToList: 'Nazad na listu',
    moreActions: 'Više akcija',
    backToVehicles: 'Nazad na vozila',
    new: 'Novo',
    create: 'Kreiraj',
    list: 'Lista',
    none: 'Nijedno',
    all: 'Sve',
    filters: 'Filteri',
    clearFilters: 'Obriši filtere',
    noResults: 'Nema rezultata',
    rowsPerPage: 'Redova po stranici:',
    viewVehicle: 'Pogledaj vozilo',
    loading: 'Učitavanje...',
    error: 'Greška',
    success: 'Uspešno',
    required: 'Obavezno polje',
    activeContracts: 'Aktivni ugovori',
    viewAll: 'Pregledaj sve',
    errorLoadingData: 'Greška pri učitavanju podataka',
    unlimited: 'Neograničeno',
    confirm: 'Potvrdi',
    confirmTitles: {
      delete: 'Potvrda brisanja',
      archive: 'Potvrda arhiviranja',
      restore: 'Potvrda vraćanja iz arhive',
      deactivate: 'Potvrda deaktivacije',
      reactivate: 'Potvrda ponovnog aktiviranja',
      regenerate: 'Potvrda regeneracije',
    },
    show: 'Prikaži',
    hide: 'Sakrij',
    submit: 'Pošalji',
    submitting: 'Slanje...',
    yes: 'Da',
    no: 'Ne',
    notSpecified: 'Nije navedeno',
    of: 'od',
    moreThan: 'više od',
    noOptions: 'Nema opcija',
    selectOption: 'Izaberite opciju',
    months: {
      1: 'Januar',
      2: 'Februar',
      3: 'Mart',
      4: 'April',
      5: 'Maj',
      6: 'Jun',
      7: 'Jul',
      8: 'Avgust',
      9: 'Septembar',
      10: 'Oktobar',
      11: 'Novembar',
      12: 'Decembar',
    },
    pagination: {
      displayedRows: '{{from}}-{{to}} od {{total}}',
      moreThan: 'više od {{to}}',
    },
    validation: {
      // Required fields
      required: 'Ovo polje je obavezno',

      // String validation
      minLength: 'Minimalna dužina je {{min}} karaktera',
      maxLength: 'Maksimalna dužina je {{max}} karaktera',
      exactLength: 'Dužina mora biti tačno {{length}} karaktera',

      // Number validation
      min: 'Minimalna vrednost je {{min}}',
      max: 'Maksimalna vrednost je {{max}}',
      positive: 'Vrednost mora biti pozitivan broj',
      nonNegative: 'Vrednost ne može biti negativna',
      integer: 'Vrednost mora biti ceo broj',

      // Format validation
      invalidEmail: 'Nevažeća email adresa',
      invalidPhone: 'Nevažeći broj telefona',
      invalidUrl: 'Nevažeći URL',
      invalidDate: 'Nevažeći datum',

      // Date validation
      dateInPast: 'Datum mora biti u prošlosti',
      dateInFuture: 'Datum mora biti u budućnosti',
      dateTodayOrFuture: 'Datum mora biti danas ili u budućnosti',
      dateAfter: 'Datum mora biti posle {{date}}',
      dateBefore: 'Datum mora biti pre {{date}}',
      endDateAfterStartDate: 'Datum završetka mora biti posle datuma početka',

      // Custom validations
      duplicate: 'Ova vrednost već postoji',
      notFound: 'Vrednost nije pronađena',
      invalidFormat: 'Nevažeći format',

      // General
      invalidValue: 'Nevažeća vrednost',
    },
    errors: {
      // General errors
      saveFailed: 'Greška pri čuvanju podataka',
      loadFailed: 'Greška pri učitavanju podataka',
      deleteFailed: 'Greška pri brisanju',
      unauthorized: 'Nemate dozvolu za ovu akciju',
      networkError: 'Greška u mreži. Proverite internet konekciju',
      unknownError: 'Došlo je do nepoznate greške',
      validationErrors: 'Molimo ispravite sledeće greške:',
    },
    unauthorized: {
      title: 'Neovlašćen pristup',
      message: 'Nemate dozvolu za pristup ovoj stranici.',
      contactAdmin: 'Kontaktirajte administratora ako smatrate da je ovo greška.',
    },
    notFound: {
      title: 'Stranica nije pronađena',
      description: 'Stranica koju tražite ne postoji ili je uklonjena.',
      goHome: 'Idi na početnu',
    },
  },
  app: {
    title: 'Platforma za poslovanje',
    company: 'Transportgas Srbija',
    moduleSwitcher: {
      title: 'Moduli',
      change: 'Promeni modul',
      changeCurrent: 'Promeni modul, trenutno {{name}}',
      externalHint: 'Otvara se u novom tabu',
    },
    moduleChooser: {
      title: 'Izaberite modul',
      subtitle: 'Sledeći put ćete biti vraćeni u modul u kome ste poslednji put radili.',
    },
  },
  language: {
    latin: 'Latinica',
    cyrillic: 'Ćirilica',
    latinShort: 'Lat',
    cyrillicShort: 'Ćir',
  },
  roles: {
    systemAdmin: 'Sistem Administrator',
    fleetManager: 'Menadžer',
    fleetUser: 'Korisnik',
    fleetViewOnly: 'Pregled voznog parka',
    fleetTireService: 'Vulkanizerske usluge',
    fleetRegistrations: 'Registracije vozila',
    fleetServices: 'Servisi vozila',
    fleetTravelOrders: 'Putni nalozi',
    fleetRequestForOthers: 'Zahtevi u tuđe ime',
    contractManager: 'Menadžer ugovora',
    userAdmin: 'Administrator korisnika',
    hrManager: 'Kadrovska',
    documentArchiveUser: 'Korisnik arhive dokumenata',
  },
  nav: {
    dashboard: 'Kontrolna tabla',
  },
  modules: {
    fleet: {
      name: 'Vozni park',
    },
    users: {
      name: 'Korisnici',
    },
    humanResources: {
      name: 'Kadrovska',
    },
  },
  fleets: {
    dashboard: {
      subtitle: 'Pregled voznog parka',
    },
    nav: {
      vehicles: 'Vozila',
      allVehicles: 'Sva vozila',
      requests: 'Zahtevi',
      operations: 'Operacije',
      services: 'Servisni troškovi',
      fuel: 'Gorivo',
      tires: 'Vulkanizerski troškovi',
      registrations: 'Registracije',
      contracts: 'Ugovori',
      activeContracts: 'Aktivni ugovori',
      providers: 'Dobavljači',
      travelOrders: 'Vožnje',
      travelOrderPeriods: 'Putni nalozi',
      fleetUsers: 'Korisnici',
      myAccount: 'Moj nalog',
      reports: 'Izveštaji',
      tireTracking: 'Evidencija guma',
      workOrders: 'Radni nalozi',
      operationalUnits: 'Org. jedinice',
    },
    vehicles: {
      title: 'Vozila',
      subtitle: 'Jednostavan uvid u detalje vozila',
      noVehicles: 'Nema vozila u vašoj organizacionoj jedinici.',
      add: 'Dodaj vozilo',
      addVehicle: 'Dodaj novo vozilo',
      editVehicle: 'Izmeni vozilo',
      createRequest: 'Kreiraj zahtev',
      createRequestTooltip: 'Kreiraj zahtev za korišćenje vozila',
      notFound: 'Vozilo nije pronađeno',
      registration: 'Registarska oznaka',
      assignedTo: 'Zadužio',
      travelOrderHolder: 'Nosilac naloga',
      travelOrderHolderPrevious: 'Poslednji nalog, nije aktivan',
      brand: 'Marka',
      model: 'Model',
      type: 'Tip',
      year: 'Godina',
      status: 'Status',
      color: 'Boja',
      chassisNumber: 'Broj šasije',
      engineNumber: 'Broj motora',
      enginePower: 'Snaga motora',
      fuelType: 'Tip goriva',
      mileage: 'Kilometraža',
      registrationNumber: 'Broj saobraćajne',
      internalCode: 'Interni broj',
      registrationDate: 'Datum registracije',
      registrationExpiry: 'Istek registracije',
      generalInfo: 'Opšti podaci',
      basicInfoMenu: 'Podaci o vozilu',
      registrationInfo: 'Registracija',
      vehicleIsRegistered: 'Vozilo je registrovano',
      technicalInfo: 'Tehnički podaci',
      serviceHistory: 'Istorija servisa',
      tireServiceHistory: 'Istorija vulkanizerskih troškova',
      fuelLogs: 'Evidencija goriva',
      noServiceHistory: 'Nema istorije servisa',
      noTireServiceHistory: 'Nema istorije vulkanizerskih troškova',
      noFuelLogs: 'Nema evidencije goriva',
      noDocuments: 'Nema dokumenata',
      tabs: {
        basicInfo: 'Osnovni podaci',
        services: 'Servisni troškovi',
        vulcanizerServices: 'Vulkanizerski troškovi',
        registrations: 'Registracije',
        fuel: 'Gorivo',
        assigmnets: 'Dodele',
        travelOrderPeriods: 'Putni nalozi',
        unavailability: 'Nedostupnost',
        tires: 'Gume',
        travelOrders: 'Vožnje',
        unitTransfers: 'Premeštaji',
        odometerCorrections: 'Korekcije kilometraže',
      },
      assignmentTab: {
        title: 'Dodeljenje vozila',
        assign: 'Dodeli vozilo',
        currentAssignment: 'Trenutna dodela',
        assignedToUser: 'Dodeljen korisniku',
        contractNumber: 'Broj ugovora',
        assignmentPeriod: 'Period dodele',
        indeterminate: 'Neodređeno',
        activeTravelOrder: 'Aktivni putni nalog',
        active: 'Aktivni',
        responsiblePerson: 'Nosilac naloga',
        tripCount: 'Broj vožnji',
        view: 'Pogledaj',
        createNewPeriod: 'Kreiraj novi putni nalog',
        noPeriodCurrentMonth: 'Nema putnog naloga za tekući mesec',
        createPeriod: 'Kreiraj putni nalog',
        noActiveAssignment: 'Vozilo nema aktivnu dodelu.',
      },
      travelOrderPeriodsTab: {
        title: 'Putni nalozi',
        empty: 'Nema putnih naloga za ovo vozilo',
      },
      unavailabilityTab: {
        title: 'Nedostupnost vozila',
        activeOnly: 'Samo aktivne',
        all: 'Sve',
        create: 'Nova nedostupnost',
      },
      tiresTab: {
        title: 'Gume na vozilu',
        addNew: 'Dodaj novu gumu',
        mountExisting: 'Montiraj postojeću',
        empty: 'Nema montiranih guma na ovom vozilu.',
      },
      travelOrdersTab: {
        title: 'Vožnje',
      },
      unitTransfersTab: {
        title: 'Istorija premeštaja između jedinica',
        empty: 'Vozilo nije premeštano između jedinica.',
        transferredAt: 'Datum premeštaja',
        from: 'Iz jedinice',
        to: 'U jedinicu',
        transferredBy: 'Izvršio',
        notes: 'Napomena',
      },
      odometerCorrectionsTab: {
        title: 'Istorija korekcija kilometraže',
      },
      requestPool: {
        label: 'Dostupno za zahteve',
        notAvailable: 'Nije dostupno za zahteve',
        outOfPool: 'Van pool-a',
        tooltip: 'Kontroliše da li standardni korisnici vide ovo vozilo i mogu da ga zatraže',
        yes: 'Da',
        no: 'Ne',
      },
      createPeriod: {
        title: 'Kreiraj putni nalog',
        description: 'Kreiranje novog putnog naloga za vozilo {{plate}}.',
        vehicle: 'Vozilo',
        responsiblePerson: 'Nosilac naloga',
        month: 'Mesec',
        year: 'Godina',
        creating: 'Kreiranje...',
        submit: 'Kreiraj putni nalog za {{period}}',
      },
      // Form field labels (matching English property names)
      fields: {
        plateNumber: 'Registarska oznaka',
        plateNumberHint: 'Unosi se bez razmaka i crtica, npr. NS123AB',
        brand: 'Marka',
        model: 'Model',
        vehicleType: 'Tip vozila',
        productionDate: 'Datum proizvodnje',
        chassisNumber: 'Broj šasije',
        registrationNumber: 'Broj saobraćajne',
        registrationDate: 'Datum registracije',
        registrationExpiry: 'Istek registracije',
        wheelDimension: 'Dimenzija točka',
        odometer: 'Kilometraža',
        engineNumber: 'Broj motora',
        powerKW: 'Snaga motora (kW)',
        capacityCM3: 'Zapremina (cm³)',
        fuelType: 'Tip goriva',
        color: 'Boja',
        passengerSeats: 'Broj sedišta',
        fuelCardNumber: 'Broj kartice za gorivo',
        currentDriverId: 'Zaposleni',
        referenceConsumption: 'Referentna potrošnja (L/100km)',
        referenceConsumptionHelper: 'Očekivana fabrička potrošnja vozila. Ostavite prazno da onemogućite analizu.',
        consumptionTolerance: 'Tolerancija (±%)',
        consumptionToleranceHelper: 'Dozvoljeno odstupanje od reference, simetrično u oba smera (npr. 10 znači ±10%).',
      },
      filters: {
        brand: 'Marka',
        brandPlaceholder: 'Npr. Toyota',
        plateNumber: 'Registarska oznaka',
        plateNumberPlaceholder: 'Npr. NS501NZ ili 501',
        travelOrderHolder: 'Nosilac putnog naloga',
        travelOrderHolderPlaceholder: 'Ime ili prezime',
        internalCode: 'Interni broj',
        internalCodePlaceholder: 'Npr. BG, NS ili PA-1',
        operationalUnit: 'Transportna jedinica',
        operationalUnitPlaceholder: 'Izaberite jedinice',
        fuelTypePlaceholder: 'Izaberite tip goriva',
        availableFrom: 'Dostupno od',
        availableTo: 'Dostupno do',
        assignmentStatus: 'Status dodeljivanja',
        assignmentStatusPlaceholder: 'Izaberite status',
        withAssignee: 'Sa dodeljenim korisnikom',
        withoutAssignee: 'Bez dodeljenog korisnika',
        requestPool: 'Pool zahteva',
        requestPoolPlaceholder: 'Izaberite status',
        inRequestPool: 'U pool-u zahteva',
        notInRequestPool: 'Van pool-a zahteva',
      },
      columns: {
        internalCode: 'Broj',
        requestPool: 'Za zahteve',
      },
      consumptionAnalysis: 'Analiza potrošnje goriva',
      vehicleTypes: {
        Passenger: 'Putničko',
        Cargo: 'Teretno',
        Special: 'Specijalno',
        Work: 'Radno',
        Trailer: 'Priključno',
      },
      statuses: {
        Active: 'Aktivno',
        Sold: 'Prodato',
        Scrapped: 'Otpisano',
        Unknown: 'Nepoznato',
      },
      unavailableReason: 'Vozilo je {{status}}',
      availability: {
        title: 'Dostupnost vozila',
        errorLoading: 'Greška pri učitavanju podataka o dostupnosti',
        free: 'Slobodno',
        hoursOf24: '{{hours}}h od 24h ({{percent}}%)',
        eventTypes: {
          travelOrder: 'Zauzeto',
          service: 'Servis',
          outOfService: 'Van funkcije',
          manual: 'Rezervacija',
          unavailable: 'Nedostupno',
        },
      },
      adjustOdometer: {
        title: 'Korekcija kilometraže',
        button: 'Korekcija',
        odometerHelper: 'Kilometraža se ažurira putem vožnji ili korekcije',
        newOdometer: 'Novo stanje kilometraže',
        reason: 'Razlog korekcije',
        reasonHelper: 'Obavezno: Unesite razlog za korekciju kilometraže',
        currentState: 'Trenutno stanje:',
        saving: 'Spremanje...',
        submit: 'Ažuriraj kilometražu',
        allowedRange: 'Dozvoljeni opseg za novo stanje',
        belowLastReadingInfo: 'Novo stanje ne može biti manje od poslednjeg očitavanja. Ako je neko očitavanje pogrešno, ispravite ga na vožnji ili putnom nalogu.',
        validation: {
          odometerRequired: 'Unesite novo stanje kilometraže',
          odometerNonNegative: 'Kilometraža ne može biti negativna',
          odometerDifferent: 'Nova kilometraža mora biti različita od trenutne',
          reasonRequired: 'Razlog korekcije je obavezan',
          reasonTooLong: 'Razlog ne može biti duži od 500 karaktera',
          belowLastReading: 'Stanje ne može biti manje od poslednjeg očitavanja ({{value}}). Ispravite pogrešno očitavanje na vožnji ili putnom nalogu.',
        },
      },
      transfer: {
        button: 'Premesti',
        title: 'Premeštaj vozila {{plate}}',
        currentUnit: 'Trenutna jedinica:',
        info: 'Premeštaj važi od danas. Otvoreni putni nalog i buduće vožnje prelaze u novu jedinicu, a raniji zapisi ostaju u staroj jedinici.',
        targetUnit: 'Nova jedinica',
        targetUnitHelper: 'Ako se menja grad, vozilo dobija novi interni broj.',
        newDriver: 'Novi zaduženi zaposleni (opciono)',
        newDriverHelper: 'Ostavite prazno da zaduženje ostane nepromenjeno.',
        transferPeriodHolder: 'Prenesi i nosioca otvorenog putnog naloga',
        notes: 'Napomena',
        saving: 'Premeštanje...',
        submit: 'Premesti vozilo',
        unitReadOnlyHelper: 'Jedinica se menja preko opcije „Premesti” na stranici vozila.',
        validation: {
          targetUnitRequired: 'Izaberite novu jedinicu',
          notesTooLong: 'Napomena ne može biti duža od 500 karaktera',
        },
      },
    },
    services: {
      title: 'Servisi',
      subtitle: 'Pregled i upravljanje servisima vozila',
      add: 'Novi servis',
      create: 'Novi servis',
      edit: 'Izmeni servis',
      pending: 'na čekanju',
      loading: 'Učitavanje servisa...',
      notFound: 'Servis nije pronađen ili je došlo do greške pri učitavanju.',
      errorLoading: 'Greška pri učitavanju servisa. Pokušajte ponovo.',
      notSpecified: 'Nije navedeno',
      viewVehicle: 'Pogledaj vozilo',

      // Table columns
      vehicle: 'Vozilo',
      type: 'Tip',
      description: 'Opis',
      scheduledDate: 'Datum',
      provider: 'Serviser',
      cost: 'Trošak',
      status: 'Status',

      // Form sections
      form: {
        basicInfo: 'Osnovni podaci',
        providerSection: 'Dobavljač / Serviser',
        invoiceSection: 'Faktura i napomene',
        itemsSection: 'Stavke servisa',
        notesSection: 'Napomene',
        newService: 'Novi servis',
        editService: 'Izmeni servis',
      },

      // Fields
      fields: {
        vehicle: 'Vozilo',
        odometerReading: 'Stanje kilometraže',
        description: 'Opis servisa',
        descriptionPlaceholder: 'Npr. Redovan servis 30.000 km - zamena ulja i filtera',
        provider: 'Dobavljač',
        providerNotSelected: 'Nije odabrano',
        providerNone: 'Nije odabrano',
        contract: 'Ugovor',
        customProviderName: 'Naziv servisera (ručni unos)',
        invoiceNumber: 'Broj fakture',
        notes: 'Napomene',
        notesPlaceholder: 'Dodatne napomene o servisu...',
      },

      // Detail page
      detail: {
        basicInfo: 'Osnovni podaci',
        vehicle: 'Vozilo',
        odometer: 'Kilometraža',
        createdAt: 'Datum kreiranja',
        updatedAt: 'Datum izmene',
        invoiceNumber: 'Broj fakture',
        provider: 'Dobavljač',
        totalCost: 'Ukupan trošak',
        notes: 'Napomene',
        items: 'Stavke servisa',
        itemCount: 'stavka',
        itemsCount: 'stavki',
      },

      // Service items
      items: {
        title: 'Stavke servisa',
        add: 'Dodaj stavku',
        addButton: 'Dodaj',
        edit: 'Izmeni stavku',
        editTooltip: 'Izmeni',
        delete: 'Obriši stavku',
        deleteTooltip: 'Obriši',
        noItems: 'Nema stavki',
        noItemsHint: 'Kliknite "Dodaj stavku" da dodate prvu stavku servisa',
        noItemsHintMobile: 'Kliknite "Dodaj" da dodate prvu stavku servisa',
        noItemsDetail: 'Ovaj servis nema dodanih stavki',
        total: 'Ukupno',
        totalLabel: 'UKUPNO:',

        // Table columns
        type: 'Tip',
        description: 'Opis',
        quantity: 'Kol.',
        quantityFull: 'Količina',
        unitPrice: 'Cena',
        unitPriceFull: 'Cena po jedinici',
        totalPrice: 'Ukupno',
        actions: 'Akcije',

        // Item types
        types: {
          Other: 'Ostalo',
          Work: 'Rad',
          Part: 'Deo',
          Tire: 'Guma',
          Fee: 'Naknada',
        },
      },

      // Add/Edit item dialog
      itemDialog: {
        addTitle: 'Dodaj stavku',
        editTitle: 'Izmeni stavku',
        itemType: 'Tip stavke',
        description: 'Opis',
        descriptionPlaceholder: 'Npr. Zamena ulja i filtera',
        quantity: 'Količina',
        unitPrice: 'Cena po jedinici',
        unitPriceHint: 'Sa PDV-om (bruto)',
        tireDetails: 'Detalji gume',
        tireType: 'Tip gume',
        tireAction: 'Akcija',
        tireSize: 'Dimenzija',
        tireSizePlaceholder: '205/55R16',
        tireDiameter: 'Prečnik (felne)',
        tireDotCode: 'DOT kod (opciono)',
        tireDotCodePlaceholder: '2423',
        tireDotCodeHint: 'Sedmica i godina proizvodnje (npr. 2423 = 24. sedmica 2023)',
        save: 'Sačuvaj izmene',
        add: 'Dodaj',
        cancel: 'Otkaži',
        validationError: 'Molimo ispravite sledeće greške:',

        // Validation messages
        fieldRequired: 'Ovo polje je obavezno',
        quantityMustBePositive: 'Količina mora biti veća od 0',
        priceMustBeNonNegative: 'Cena mora biti 0 ili veća',
      },

      // Tire types
      tireTypes: {
        Summer: 'Letnja',
        Winter: 'Zimska',
        AllSeason: 'Celogodišnja',
      },

      // Tire actions
      tireActions: {
        Other: 'Ostalo',
        GroupAction: 'Grupna akcija',
        Purchase: 'Kupovina',
        Replace: 'Zamena',
        Storage: 'Skladištenje',
        Dispose: 'Otpis',
      },

      // Actions
      actions: {
        viewVehicle: 'Pogledaj vozilo',
        edit: 'Izmeni',
        delete: 'Obriši',
        save: 'Sačuvaj',
        saving: 'Čuvanje...',
        cancel: 'Otkaži',
      },

      // Validation
      validation: {
        vehicleRequired: 'Vozilo je obavezno',
        odometerRequired: 'Stanje kilometraže je obavezno',
        odometerPositive: 'Stanje kilometraže mora biti pozitivan broj',
        odometerCannotDecrease: 'Stanje kilometraže ne može biti manje od trenutnog stanja vozila ({{current}} km). Uneli ste: {{provided}} km',
        descriptionRequired: 'Opis je obavezan',
        descriptionMinLength: 'Opis mora imati najmanje 10 karaktera',
        itemTypeRequired: 'Tip stavke je obavezan',
        itemDescriptionRequired: 'Opis stavke je obavezan',
        quantityRequired: 'Količina je obavezna',
        quantityPositive: 'Količina mora biti pozitivan broj',
        unitPriceRequired: 'Cena je obavezna',
        unitPricePositive: 'Cena mora biti pozitivan broj',
        tireSizeRequired: 'Dimenzija gume je obavezna',
        tireDiameterRequired: 'Prečnik gume je obavezan',
        invoiceNumberRequired: 'Broj fakture je obavezan',
        contractRequired: 'Ugovor je obavezan kada je odabran dobavljač',
        customProviderNameRequired: 'Naziv servisera je obavezan kada dobavljač nije odabran',
        itemsRequired: 'Bar jedna stavka je obavezna',
      },

      // Helper texts
      helpers: {
        currentOdometer: 'Trenutno stanje: {{odometer}} km',
      },

      // Success messages
      success: {
        created: 'Servis je uspešno kreiran',
        updated: 'Servis je uspešno ažuriran',
        deleted: 'Servis je uspešno obrisan',
        itemAdded: 'Stavka je uspešno dodata',
        itemUpdated: 'Stavka je uspešno ažurirana',
        itemDeleted: 'Stavka je uspešno obrisana',
      },

      // Error messages
      errors: {
        createFailed: 'Greška pri kreiranju servisa',
        updateFailed: 'Greška pri ažuriranju servisa',
        deleteFailed: 'Greška pri brisanju servisa',
        loadFailed: 'Greška pri učitavanju servisa',
        itemAddFailed: 'Greška pri dodavanju stavke',
        itemUpdateFailed: 'Greška pri ažuriranju stavke',
        itemDeleteFailed: 'Greška pri brisanju stavke',
      },

      // Dialogs
      deleteConfirmTitle: 'Obriši servis',
      deleteConfirmMessage: 'Da li ste sigurni da želite da obrišete ovaj servis? Ova akcija se ne može poništiti.',
      deleteItemTitle: 'Obriši stavku',
      deleteItemMessage: 'Da li ste sigurni da želite da obrišete ovu stavku?',
    },
    providers: {
      title: 'Dobavljači',
      subtitle: 'Pregled dobavljača za vozni park',
      create: 'Novi dobavljač',
      edit: 'Izmeni dobavljača',
      notFound: 'Dobavljač nije pronađen',
      viewAllServiceTypes: 'Prikaži sve tipove usluga',
      search: 'Pretraži dobavljače...',
      noResults: 'Nema dobavljača koji odgovaraju pretrazi',
      empty: 'Nema dobavljača',
      fields: {
        name: 'Naziv',
        serviceTypes: 'Tipovi usluga',
        contactEmail: 'Email',
        contactPhone: 'Telefon',
        address: 'Adresa',
        taxId: 'PIB',
        notes: 'Napomene',
        activeContracts: 'Aktivni ugovori',
      },
      serviceTypes: {
        Service: 'Servis',
        Repair: 'Popravka',
        Tire: 'Gume',
        Fuel: 'Gorivo',
        Registration: 'Registracija',
        TechnicalInspection: 'Tehnički pregled',
        Insurance: 'Osiguranje',
        Cleaning: 'Čišćenje',
        Other: 'Ostalo',
      },
      details: {
        info: 'Informacije o dobavljaču',
        contracts: 'Ugovori',
        noContracts: 'Nema ugovora',
      },
    },
    contracts: {
      title: 'Ugovori',
      subtitle: 'Pregled ugovora vezanih za vozni park',
      create: 'Novi ugovor',
      edit: 'Izmeni ugovor',
      notFound: 'Ugovor nije pronađen',
      search: 'Pretraži ugovore...',
      noResults: 'Nema ugovora koji odgovaraju pretrazi',
      empty: 'Nema ugovora',
      add: 'Novi ugovor',
      number: 'Broj ugovora',
      type: 'Tip',
      supplier: 'Dobavljač',
      vehicle: 'Vozilo',
      startDate: 'Početak',
      endDate: 'Istek',
      value: 'Vrednost',
      status: 'Status',
      expiringWarning: '{{count}} ugovor(a) ističe uskoro',
      expiredWarning: '{{count}} ugovor(a) je isteklo',
      viewProvider: 'Pogledaj dobavljača',
      viewAllScopes: 'Prikaži sve obuhvate',
      fields: {
        providerId: 'Dobavljač',
        provider: 'Dobavljač',
        contractNumber: 'Broj ugovora',
        scopes: 'Obuhvat',
        validFrom: 'Važeći od',
        validTo: 'Važeći do',
        contractAmountNet: 'Iznos ugovora (bez PDV-a)',
        contractAmountNetShort: 'Iznos (NET)',
        vatRate: 'Stopa PDV-a',
        contractAmountGross: 'Iznos ugovora (sa PDV-om)',
        contractAmountGrossShort: 'Iznos (BRUTO)',
        remainingAmountGrossShort: 'Preostalo (BRUTO)',
        contractAmountHint: 'Unesite iznos ugovora sa PDV-om',
        consumedAmountNet: 'Potrošeno (NET)',
        consumedAmountGross: 'Potrošeno (BRUTO)',
        remainingAmountNet: 'Preostalo (NET)',
        remainingAmountGross: 'Preostalo (BRUTO)',
        status: 'Status',
        notes: 'Napomene',
      },
      details: {
        info: 'Informacije o ugovoru',
      },
      scopes: {
        Service: 'Servis',
        Repair: 'Popravka',
        Tire: 'Gume',
        Fuel: 'Gorivo',
        Registration: 'Registracija',
        TechnicalInspection: 'Tehnički pregled',
        Insurance: 'Osiguranje',
        Cleaning: 'Čišćenje',
        Other: 'Ostalo',
      },
      statuses: {
        Draft: 'Nacrt',
        Active: 'Aktivan',
        Expired: 'Istekao',
        Terminated: 'Raskinut',
      },
      expiringSoon: 'Ističe uskoro',
    },
    tireProcurement: {
      title: 'Vulkanizerski troškovi',
      subtitle: 'Pregled vulkanizerskih troškova za vozni park',
      add: 'Nova nabavka',
      inProgress: 'u toku',
      activeCount: '{{count}} aktivna nabavka(e) u toku',
      number: 'Broj nabavke',
      vehicle: 'Vozilo',
      type: 'Tip gume',
      size: 'Dimenzija',
      quantity: 'Količina',
      supplier: 'Dobavljač',
      date: 'Datum',
      price: 'Cena',
      status: 'Status',
    },
    travelOrders: {
      title: 'Vožnje',
      subtitle: 'Pregled i upravljanje vožnjama',
      fields: {
        orderNumber: 'Broj vožnje',
        vehiclePlateNumber: 'Registarska oznaka',
        purpose: 'Svrha',
        destination: 'Destinacija',
        plannedStartDate: 'Planirani početak',
        plannedEndDate: 'Planirani završetak',
        status: 'Status',
      },
      statuses: {
        Open: 'Otvoren',
        InProgress: 'U toku',
        Completed: 'Završen',
        Closed: 'Zatvoren',
        Cancelled: 'Otkazan',
      },
      tabs: {
        my: 'Moje vožnje',
        all: 'Sve vožnje',
        responsible: 'Vožnje mojih vozila',
        overview: 'Pregled',
        notes: 'Napomene',
        fuelLogs: 'Unosi goriva',
        timeline: 'Vremenska linija',
        odometerCorrections: 'Korekcije kilometraže',
      },
      columns: {
        orderNumber: 'Broj vožnje',
        vehicle: 'Vozilo',
        driver: 'Vozač',
        period: 'Period',
        status: 'Status',
        actions: 'Akcije',
        km: 'Km',
      },
      filters: {
        plateNumber: 'Registarska oznaka',
        selectVehicle: 'Izaberite vozilo',
        fromDate: 'Od datuma',
        toDate: 'Do datuma',
      },
      tooltips: {
        view: 'Pregledaj',
        startTrip: 'Startuj vožnju',
        endTrip: 'Završi vožnju',
      },
      actions: {
        short: {
          start: 'Startuj',
          end: 'Završi',
          close: 'Zaključi',
        },
      },
      empty: {
        my: 'Nemate vožnji',
        responsible: 'Nema vožnji na vašim putnim nalozima',
        filtered: 'Nema rezultata za izabrane filtere',
        all: 'Nema vožnji',
        forVehicle: 'Nema vožnji za ovo vozilo.',
      },
      totalCount: 'Ukupno: {{count}} vožnji',
      detail: {
        title: 'Vožnja - {{number}}',
        loading: 'Učitavanje vožnje...',
        notFound: 'Vožnja nije pronađena ili je došlo do greške pri učitavanju.',
        viewRequest: 'Pogledaj zahtev',
        basicInfo: 'Osnovne informacije',
        tripDetails: 'Detalji vožnje',
        timeline: 'Vremenski tok',
        closureInfo: 'Informacije o zatvaranju/otkazivanju',
        fuelLogsEmpty: 'Nema unetih podataka o gorivu za ovu vožnju.',
        odometerCorrections: 'Istorija korekcija kilometraže',
        fields: {
          orderNumber: 'Broj vožnje',
          vehicle: 'Vozilo',
          vehicleDescription: 'Opis vozila',
          driver: 'Vozač',
          startOdometer: 'Početno stanje kilometraže',
          endOdometer: 'Završno stanje kilometraže',
          totalDistance: 'Ukupna distanca',
          destination: 'Relacija',
          duration: 'Trajanje',
          plannedStart: 'Planirani početak',
          plannedEnd: 'Planirani završetak',
          actualStart: 'Stvarni početak',
          actualEnd: 'Stvarni završetak',
          startNotes: 'Napomene pri početku',
          endNotes: 'Napomene pri završetku',
          createdAt: 'Kreirano',
          startedAt: 'Započeto',
          completedAt: 'Završeno',
          closedAt: 'Zatvoreno',
          cancelledAt: 'Otkazano',
          startedBy: 'Startovao',
          endedBy: 'Završio',
          onBehalfOfDriver: 'umesto vozača',
          closedBy: 'Zatvorio',
          closedAtDate: 'Datum zatvaranja',
          closingNotes: 'Napomene pri zatvaranju',
          cancelledAtDate: 'Datum otkazivanja',
          cancellationReason: 'Razlog otkazivanja',
        },
        actions: {
          viewVehicle: 'Pogledaj vozilo',
          edit: 'Izmeni',
          startTrip: 'Startuj vožnju',
          endTrip: 'Završi vožnju',
          close: 'Zaključi vožnju',
          cancel: 'Otkaži vožnju',
          correctOdometer: 'Ispravi kilometražu',
        },
      },
      form: {
        createTitle: 'Kreiraj vožnju',
        editTitle: 'Izmeni vožnju',
        vehicleAndDriver: 'Vozilo i vozač',
        tripDetails: 'Detalji putovanja',
        vehicle: 'Vozilo',
        driver: 'Vozač',
        destination: 'Relacija',
        plannedStartDate: 'Planirani datum početka',
        plannedEndDate: 'Planirani datum završetka',
        submitCreate: 'Kreiraj vožnju',
        submitEdit: 'Sačuvaj izmene',
        editWarning: 'Upozorenje:',
        editWarningText: 'Menjate vožnju koja je već {{status}}. Izmene mogu uticati na izveštaje i evidenciju.',
        inProgressInfo: 'Planirani datum početka je zaključan zato što je vožnja već započeta. Planirani datum završetka možete samo produžiti.',
        completedWarning: 'Ova vožnja je završena ili zaključena i planirani datumi više ne mogu da se menjaju.',
        validation: {
          startDateRequired: 'Planirani datum početka je obavezan',
          endDateAfterStart: 'Datum završetka mora biti nakon datuma početka',
          startDateLockedInProgress: 'Planirani datum početka se ne može menjati kada je vožnja u toku',
          endDateExtendOnly: 'Planirani datum završetka se može samo produžiti kada je vožnja u toku',
          fillRequiredFields: 'Molimo popunite sva obavezna polja',
        },
      },
      odometerConflict: {
        label: 'Odstupanje kilometraže',
        tooltip: 'Kilometraža na ovoj vožnji ne uklapa se u redosled očitavanja vozila. Ispravlja je vozač dok vožnja nije zatvorena ili menadžer vožnji; putni nalog se ne može zatvoriti dok odstupanje postoji.',
      },
      dialogs: {
        details: {
          title: 'Detalji vožnje:',
          orderNumber: 'Broj vožnje:',
          vehicle: 'Vozilo:',
          driver: 'Vozač:',
          purpose: 'Svrha:',
          period: 'Period:',
          destination: 'Destinacija:',
          startOdometer: 'Početna kilometraža:',
          startedAt: 'Započeto:',
          totalDistance: 'Pređena distanca:',
          odometer: 'Kilometraža:',
        },
        start: {
          title: 'Startuj vožnju',
          description: 'Potvrdite da želite da započnete vožnju. Vozilo će biti označeno kao "U upotrebi".',
          odometerLabel: 'Početna kilometraža',
          odometerHelper: 'Unesite trenutno stanje kilometraže sa instrument table vozila',
          allowedRange: 'Dozvoljeni opseg za početnu kilometražu',
          dateLabel: 'Stvarni početak - datum',
          timeLabel: 'Stvarni početak - vreme',
          notesLabel: 'Napomene (opciono)',
          notesPlaceholder: 'Npr. Stanje vozila, posebne napomene...',
          submit: 'Startuj vožnju',
          submitting: 'Pokretanje...',
          validation: {
            dateRequired: 'Datum stvarnog početka je obavezan',
            timeRequired: 'Vreme stvarnog početka je obavezno',
            odometerRequired: 'Početna kilometraža je obavezna',
            odometerPositive: 'Početna kilometraža mora biti pozitivan broj',
          },
        },
        end: {
          title: 'Završi vožnju',
          description: 'Potvrdite završetak vožnje. Vozilo će biti vraćeno i dostupno za zaključivanje od strane administratora.',
          odometerLabel: 'Završna kilometraža',
          odometerPlaceholder: 'Najmanje {{value}} km',
          odometerHelper: 'Unesite završnu kilometražu za ažuriranje stanja vozila',
          allowedRange: 'Dozvoljeni opseg za završnu kilometražu',
          dateLabel: 'Stvarni završetak - datum',
          timeLabel: 'Stvarni završetak - vreme',
          notesLabel: 'Napomene (opciono)',
          notesPlaceholder: 'Npr. Stanje vozila, problemi tokom putovanja...',
          distanceInfo: 'Pređena distanca:',
          submit: 'Završi vožnju',
          submitting: 'Završavanje...',
          validation: {
            dateRequired: 'Datum stvarnog završetka je obavezan',
            timeRequired: 'Vreme stvarnog završetka je obavezno',
            odometerRequired: 'Završna kilometraža je obavezna',
            odometerPositive: 'Završna kilometraža mora biti pozitivan broj',
            odometerTooLow: 'Završna kilometraža ne može biti manja od {{value}} km',
          },
        },
        cancel: {
          title: 'Otkaži vožnju',
          description: 'Molimo unesite razlog otkazivanja vožnje.',
          reasonLabel: 'Razlog otkazivanja',
          reasonPlaceholder: 'Npr. Putovanje je otkazano zbog promena planova...',
          reasonHelper: 'Minimalno 10 karaktera',
          submit: 'Otkaži vožnju',
          submitting: 'Otkazivanje...',
          validation: {
            reasonRequired: 'Razlog otkazivanja je obavezan',
            reasonTooShort: 'Razlog mora imati najmanje 10 karaktera',
          },
        },
        close: {
          title: 'Zaključi vožnju',
          description: 'Potvrdite zaključivanje vožnje. Vozilo će postati dostupno za nove zahteve.',
          notesLabel: 'Napomene (opciono)',
          notesPlaceholder: 'Npr. Sve u redu, vožnja zatvorena...',
          submit: 'Zaključi vožnju',
          submitting: 'Zaključivanje...',
        },
        edit: {
          title: 'Izmeni vožnju',
          inProgressInfo: 'Vožnja je u toku: planirani početak je zaključan, a planirani završetak možete samo produžiti.',
          completedWarning: 'Završena ili zaključena vožnja više ne može da menja planirane datume.',
          purposeLabel: 'Svrha',
          purposeHelper: 'Opišite svrhu vožnje',
          purposePlaceholder: 'Npr. Službeno putovanje u Beograd',
          plannedPeriod: 'Planirani period',
          startDate: 'Datum početka *',
          startTime: 'Vreme početka',
          endDate: 'Datum završetka *',
          endTime: 'Vreme završetka',
          optional: 'Opciono',
          destinationLabel: 'Relacija',
          destinationPlaceholder: 'Npr. Beograd - Novi Sad',
          submit: 'Sačuvaj izmene',
          validation: {
            startLocked: 'Planirani početak se ne može menjati kada je vožnja u toku.',
            endExtendOnly: 'Planirani završetak se može samo produžiti kada je vožnja u toku.',
          },
        },
        notes: {
          startTitle: 'Napomene pri početku putovanja',
          endTitle: 'Napomene pri završetku putovanja',
          closingTitle: 'Napomene pri zatvaranju vožnje',
          startPlaceholder: 'Unesite napomene pri početku putovanja...',
          endPlaceholder: 'Unesite napomene pri završetku putovanja...',
          closingPlaceholder: 'Unesite napomene pri zatvaranju vožnje...',
          charCount: '{{value}}/1000 karaktera',
          empty: 'Nema napomena',
          edit: 'Izmeni napomene',
        },
        correctOdometer: {
          title: 'Ispravka kilometraže vožnje',
          description: 'Ispravite pogrešno unetu početnu i/ili završnu kilometražu. Svaka vrednost mora biti između prethodnog i sledećeg očitavanja vozila.',
          descriptionStartOnly: 'Vožnja je u toku, pa se može ispraviti samo početna kilometraža. Vrednost mora biti između prethodnog i sledećeg očitavanja vozila.',
          endedAt: 'Završeno:',
          startLabel: 'Početna kilometraža',
          endLabel: 'Završna kilometraža',
          startRange: 'Dozvoljeni opseg za početnu kilometražu',
          endRange: 'Dozvoljeni opseg za završnu kilometražu',
          currentValue: 'Trenutno uneto: {{value}}',
          reasonHelper: 'Obavezno: zašto se kilometraža ispravlja',
          correctedInOtherPeriod: 'Ispravlja se u putnom nalogu za {{period}}',
          periodNotAvailable: 'Putni nalog za {{period}} nije otvoren ili nemate ovlašćenje da ispravite ovu kilometražu',
          submit: 'Sačuvaj ispravku',
          validation: {
            endBelowStart: 'Završna kilometraža ne može biti manja od početne',
            noChanges: 'Niste promenili nijednu vrednost kilometraže',
          },
        },
      },
    },
    travelOrderPeriods: {
      title: 'Putni nalozi',
      subtitle: 'Pregled i upravljanje putnim nalozima',
      loadError: 'Greška pri učitavanju putnog naloga',
      noAccess: 'Ovaj putni nalog vam više nije dostupan.',
      detailTitle: 'Putni nalog - {{number}}',
      statuses: {
        Open: 'Otvoren',
        Closed: 'Zatvoren',
        Cancelled: 'Otkazan',
      },
      tabs: {
        my: 'Moji putni nalozi',
        all: 'Svi putni nalozi',
        trips: 'Vožnje',
        fuelLogs: 'Unosi goriva',
        holderHistory: 'Istorija nosilaca',
        odometerCorrections: 'Korekcije kilometraže',
      },
      columns: {
        orderNumber: 'Broj naloga',
        vehicle: 'Vozilo',
        period: 'Period',
        responsiblePerson: 'Nosilac naloga',
        trips: 'Vožnje',
        status: 'Status',
        actions: 'Akcije',
      },
      filters: {
        vehicle: 'Vozilo',
        selectVehicle: 'Izaberite vozilo',
        fromDate: 'Od datuma',
        toDate: 'Do datuma',
        status: 'Status',
        allStatuses: 'Svi statusi',
        active: 'Aktivni',
      },
      empty: {
        filtered: 'Nema rezultata za izabrane filtere',
        all: 'Nema putnih naloga',
      },
      badges: {
        active: 'Aktivni',
        odometerConflicts: 'Odstupanja: {{count}}',
      },
      actions: {
        close: 'Zatvori nalog',
        edit: 'Uredi',
        reopen: 'Ponovo otvori',
        changeHolder: 'Promeni nosioca',
        downloadPdf: 'Preuzmi PDF',
        generatingPdf: 'Generisanje PDF...',
        addTrip: 'Dodaj vožnju',
        enterOdometer: 'Unesi kilometražu',
      },
      info: {
        title: 'Informacije o putnom nalogu',
        orderNumber: 'Broj naloga',
        period: 'Period',
        vehicle: 'Vozilo',
        responsiblePerson: 'Nosilac naloga',
        tripCount: 'Broj vožnji',
        startOdometer: 'Početno stanje km',
        endOdometer: 'Krajnje stanje km',
        totalDistance: 'Ukupna kilometraža',
        odometerConflictCount: 'Vožnje sa odstupanjem',
        createdAt: 'Kreirano',
        closedAt: 'Zatvoreno',
        closedBy: 'Zatvorio',
        cancelledAt: 'Otkazano',
        cancellationReason: 'Razlog otkazivanja',
      },
      holderHistory: {
        title: 'Istorija nosilaca putnog naloga',
        date: 'Datum',
        fromHolder: 'Prethodni nosilac',
        toHolder: 'Novi nosilac',
        changedBy: 'Promenio',
        reason: 'Razlog',
      },
      tripsTab: {
        title: 'Vožnje u putnom nalogu',
        empty: 'Nema vožnji u ovom putnom nalogu',
        conflictsOnly: 'Samo sa odstupanjem',
        continuation: 'Nastavak iz prethodnog meseca',
        continuesNextMonth: 'Nastavlja se u sledećem mesecu',
        distanceThisMonth: 'U ovom mesecu: {{start}} → {{end}} ({{distance}})',
        distanceWholeTrip: 'Cela vožnja: {{start}} → {{end}} ({{distance}})',
        columns: {
          orderNumber: 'Broj naloga',
          status: 'Status',
          driver: 'Vozač',
          plannedPeriod: 'Planirani period',
          destination: 'Relacija',
          distance: 'Km u mesecu',
        },
      },
      fuelLogsTab: {
        title: 'Unosi goriva',
        empty: 'Nema unetih podataka o gorivu za ovaj period.',
        relink: 'Poveži gorivo',
        relinkHint: 'Ponovo poveže svako sipanje sa vožnjom u čijem je vremenu obavljeno. Bezbedno za ponavljanje.',
        relinkChanged: 'Provereno {{examined}} unosa, promenjeno {{changed}}.',
        relinkUnchanged: 'Provereno {{examined}} unosa, sve veze su već bile ispravne.',
      },
      distance: {
        trips: 'Vožnje',
        unallocated: 'Neraspoređeno',
        unallocatedTooltip: 'Razlika između kilometraže po brojaču (krajnje − početno stanje) i zbira kilometara vožnji u ovom mesecu. Kod dodeljenih vozila je uobičajena, a kod vozila iz pula znači da nedostaje vožnja.',
      },
      odometerCorrectionsTab: {
        title: 'Istorija korekcija kilometraže',
      },
      dialogs: {
        details: {
          title: 'Detalji putnog naloga:',
          orderNumber: 'Broj naloga:',
          period: 'Period:',
          vehicle: 'Vozilo:',
          responsiblePerson: 'Nosilac naloga:',
          tripCount: 'Broj vožnji:',
          startOdometer: 'Početna kilometraža:',
          tripsDistance: 'Km u vožnjama:',
          enteredEndOdometer: 'Krajnje stanje koje je uneo nosilac:',
          closedBy: 'Zatvorio:',
        },
        close: {
          title: 'Zatvori putni nalog',
          description: 'Da li ste sigurni da želite da zatvorite ovaj putni nalog? Nakon zatvaranja nećete moći dodavati nove vožnje u ovaj putni nalog.',
          finalOdometerLabel: 'Završna kilometraža (opciono)',
          defaultEntered: 'Ako polje ostavite prazno, nalog se zatvara sa krajnjim stanjem koje je uneo nosilac ({{value}}).',
          defaultDerived: 'Ako polje ostavite prazno, koristi se poslednje očitavanje vozila u ovom mesecu, a ako ga nema, početno stanje naloga ({{value}}).',
          missingMileageWarning: 'Nosilac nije uneo kilometražu za ovaj mesec, a u nalogu nema vožnji. Unesite krajnje stanje brojača sada; ono postaje kilometraža naloga.',
          odometerConflicts: 'Nalog ima vožnji sa odstupanjem kilometraže: {{count}}. Ispravite ih pre zatvaranja.',
          overrideReasonLabel: 'Razlog promene unete kilometraže',
          overrideReasonHelper: 'Obavezno: vrednost se razlikuje od stanja koje je uneo nosilac ({{value}})',
          finalOdometerHelper: 'Opciono: stanje brojača na kraju meseca. Mora biti u dozvoljenom opsegu.',
          submit: 'Zatvori putni nalog',
          submitting: 'Zatvaranje...',
        },
        cancel: {
          title: 'Otkaži putni nalog',
          description: 'Molimo unesite razlog otkazivanja putnog naloga.',
          reasonLabel: 'Razlog otkazivanja',
          reasonPlaceholder: 'Npr. Putni nalog je otkazan zbog promene planova...',
          reasonHelper: 'Minimalno 10 karaktera',
          submit: 'Otkaži putni nalog',
          submitting: 'Otkazivanje...',
          validation: {
            reasonRequired: 'Razlog otkazivanja je obavezan',
            reasonTooShort: 'Razlog mora imati najmanje 10 karaktera',
          },
        },
        reopen: {
          title: 'Ponovo otvori putni nalog',
          overlapWarning: 'Ovaj putni nalog se ne može ponovo otvoriti jer postoji drugi aktivan (otvoren) putni nalog za isto vozilo koji se preklapa sa ovim periodom. Prvo zatvorite ili otkažite preklapajući putni nalog.',
          description: 'Da li ste sigurni da želite ponovo da otvorite ovaj putni nalog? Nakon otvaranja moći ćete dodavati nove vožnje i menjati podatke perioda.',
          submit: 'Ponovo otvori',
          submitting: 'Otvaranje...',
        },
        edit: {
          title: 'Uredi putni nalog',
          cancelledWarning: 'Otkazani putni nalog se ne može uređivati.',
          odometerSection: 'Stanje kilometraže',
          startOdometerLabel: 'Početno stanje (km)',
          startOdometerHelper: 'Može se menjati samo na prvom putnom nalogu vozila i ne sme biti veće od prvog evidentiranog očitavanja',
          holderFirstPeriodInfo: 'Početno stanje unosi se samo za prvi putni nalog vozila; svaki sledeći preuzima kraj prethodnog. Uneto stanje postaje stanje vozila.',
          endOdometerInfo: 'Krajnje stanje: {{value}}',
          endOdometerPlaceholder: 'Nije postavljeno',
          totalDistance: 'Ukupna kilometraža: {{value}} km',
          reasonHelper: 'Obavezno: zašto se menja početno stanje',
          submit: 'Sačuvaj izmene',
          submitting: 'Čuvanje...',
          validation: {
            startOdometerNegative: 'Početno stanje km ne može biti negativno',
            noChanges: 'Nema promena za čuvanje',
          },
        },
        changeHolder: {
          title: 'Promeni nosioca putnog naloga',
          orderLabel: 'Putni nalog:',
          currentHolder: 'Trenutni nosilac:',
          newHolderLabel: 'Novi nosilac',
          reasonLabel: 'Razlog promene',
          reasonPlaceholder: 'Npr. Godišnji odmor trenutnog nosioca...',
          optional: 'Opciono',
          submit: 'Promeni nosioca',
          submitting: 'Promena...',
          validation: {
            newHolderRequired: 'Novi nosilac je obavezan',
          },
        },
        createTrip: {
          title: 'Dodaj vožnju',
          description: 'Kreiranje vožnje u putnom nalogu:',
          driverLabel: 'Vozač',
          holderAsDriverInfo: 'Vožnja se kreira sa vama kao vozačem. Vožnju za drugog vozača podnesite kao zahtev za vozilo.',
          startDate: 'Datum početka *',
          startTime: 'Vreme početka',
          endDate: 'Datum završetka',
          endTime: 'Vreme završetka',
          optional: 'Opciono',
          destinationLabel: 'Relacija',
          submit: 'Kreiraj vožnju',
          submitting: 'Kreiranje...',
          validation: {
            driverRequired: 'Vozač je obavezan',
            startDateRequired: 'Datum početka je obavezan',
          },
        },
        enterOdometer: {
          title: 'Unos kilometraže na putni nalog',
          description: 'Unesite stanje brojača vozila na kraju meseca. Pređeni kilometri naloga računaju se kao razlika krajnjeg i početnog stanja.',
          enteredValue: 'Uneto krajnje stanje:',
          allowedRange: 'Dozvoljeni opseg na kraju meseca',
          rangeNote: 'Granice su očitavanja vozila neposredno pre i posle kraja meseca.',
          earlyEntryWarning: 'Mesec još nije pri kraju. Uneta vrednost postaje gornja granica za sve vožnje ovog meseca posle današnjeg dana, a stanje vozila je odmah prikazuje. Unesite kilometražu na kraju meseca, osim ako se vozilo ovog meseca više neće koristiti.',
          endOdometerLabel: 'Krajnje stanje kilometraže',
          endOdometerHelper: 'Stanje brojača na poslednji dan meseca',
          totalDistance: 'Ukupno pređeno u nalogu:',
          reasonHelper: 'Obavezno pri izmeni već unete vrednosti',
          submit: 'Sačuvaj kilometražu',
          validation: {
            belowStart: 'Krajnje stanje ne može biti manje od početnog ({{value}})',
            noChanges: 'Uneta vrednost je ista kao postojeća',
          },
        },
      },
    },
    odometer: {
      reasonLabel: 'Razlog ispravke',
      readingKinds: {
        TripStart: 'početak vožnje',
        TripEnd: 'kraj vožnje',
        PeriodEnd: 'kraj putnog naloga',
        VehicleCorrection: 'ručna korekcija vozila',
      },
      bounds: {
        previous: 'Prethodno očitavanje (najmanje)',
        next: 'Sledeće očitavanje (najviše)',
        initialOdometer: 'Početno stanje vozila (najmanje)',
        none: 'nema',
        range: 'od {{from}} do {{to}}',
        loading: 'Učitavanje dozvoljenog opsega...',
        loadError: 'Dozvoljeni opseg nije moguće učitati. Vrednost će proveriti server pri čuvanju.',
        dependsOnMoment: 'Opseg zavisi od unetog datuma i vremena i osvežava se kada ih promenite.',
      },
      chainWarning: {
        belowPrevious: 'Uneta vrednost odstupa od prethodnog očitavanja ({{value}}). Unesite stvarno stanje brojača i objasnite u napomeni; menadžer vožnji će uskladiti.',
        aboveNext: 'Uneta vrednost odstupa od sledećeg očitavanja ({{value}}). Unesite stvarno stanje brojača i objasnite u napomeni; menadžer vožnji će uskladiti.',
        belowInitial: 'Uneta vrednost odstupa od početnog stanja vozila ({{value}}). Unesite stvarno stanje brojača i objasnite u napomeni; menadžer vožnji će uskladiti.',
      },
      validation: {
        required: 'Unesite stanje kilometraže',
        invalid: 'Kilometraža mora biti nenegativan ceo broj',
        belowPrevious: 'Vrednost ne može biti manja od prethodnog očitavanja ({{value}})',
        aboveNext: 'Vrednost ne može biti veća od sledećeg očitavanja ({{value}})',
        reasonRequired: 'Razlog je obavezan',
        reasonTooLong: 'Razlog ne može biti duži od {{max}} karaktera',
      },
      corrections: {
        empty: 'Nema korekcija kilometraže',
        loadError: 'Greška pri učitavanju istorije korekcija kilometraže',
        columns: {
          date: 'Datum',
          target: 'Ispravljeno na',
          field: 'Polje',
          change: 'Staro → novo',
          reason: 'Razlog',
          correctedBy: 'Ispravio',
          status: 'Status',
          actions: 'Akcije',
        },
        fields: {
          Start: 'Početna kilometraža',
          End: 'Završna kilometraža',
          Current: 'Stanje vozila',
        },
        targetTypes: {
          Trip: 'Vožnja',
          TravelOrderPeriod: 'Putni nalog',
          Vehicle: 'Vozilo',
        },
        active: 'Važeća',
        voided: 'Stornirana',
        voidReason: 'Razlog storna',
        voidAction: 'Storniraj',
      },
      void: {
        title: 'Storniranje korekcije kilometraže',
        description: 'Stornirate ručnu korekciju vozila na {{value}} od {{date}}. Stornirana korekcija više ne učestvuje u lancu očitavanja, a stanje vozila se ponovo izračunava.',
        reasonLabel: 'Razlog storna',
        reasonHelper: 'Obavezno: zašto je korekcija bila pogrešna',
        submit: 'Storniraj',
        submitting: 'Storniranje...',
      },
    },
    trips: {
      title: 'Vožnje',
    },
    reports: {
      title: 'Izveštaji',
      sections: {
        Identification: 'Identifikacija',
        OperationalUnit: 'Transportna jedinica',
        Engine: 'Motor i tehnika',
        Registration: 'Registracija',
        Assignment: 'Dodela',
        Blocks: 'Blokade',
        Service: 'Servis',
        Vulcanizer: 'Vulkanizer',
        Tires: 'Gume',
      },
      dialog: {
        openButton: 'Izveštaj (Excel)',
        title: 'Izveštaj o vozilima',
        subtitle: 'Izaberite kolone i opseg, proverite pregled i preuzmite Excel fajl.',
        columns: 'Kolone',
        preset: 'Osnovni set',
        clear: 'Očisti',
        settings: 'Opseg i podešavanja',
        reportName: 'Naziv izveštaja',
        reportNamePlaceholder: 'npr. Vozila – registracija ističe',
        units: 'Transportne jedinice',
        unitsHelp: 'Prazno = sve jedinice koje su vam dostupne.',
        asOfDate: 'Datum preseka',
        asOfDateHelp: 'Za starost, važenje registracije, aktivne dodele i blokade.',
        sortBy: 'Sortiranje',
        sortDefault: 'Podrazumevano (jedinica, interni broj)',
        asc: 'Rastuće',
        desc: 'Opadajuće',
        preview: 'Pregled',
        previewAction: 'Pregled',
        previewHint: 'Prikazano prvih {{count}} redova.',
        totalVehicles: 'Ukupno vozila: {{count}}',
        noRows: 'Nema vozila koja odgovaraju izabranom opsegu.',
        export: 'Preuzmi Excel',
        summaryColumns: '{{count}} kolona',
        summaryUnits: '{{count}} jedinica',
        summaryAllUnits: 'sve dostupne jedinice',
        summaryAsOf: 'presek {{date}}',
      },
      templates: {
        title: 'Šabloni',
        load: 'Učitaj šablon',
        none: 'Bez šablona',
        sharedShort: 'Deljen',
        update: 'Sačuvaj izmene u šablon',
        saveAs: 'Sačuvaj kao novi šablon',
        delete: 'Obriši šablon',
        saveTitle: 'Sačuvaj šablon',
        name: 'Naziv šablona',
        visibility: {
          Private: 'Samo ja',
          Shared: 'Deljen sa timom voznog parka',
        },
        deleteConfirm: 'Obrisati šablon „{{name}}“?',
        loadError: 'Šablon nije moguće učitati.',
        saveError: 'Šablon nije moguće sačuvati.',
        deleteError: 'Šablon nije moguće obrisati.',
      },
    },
    requests: {
      title: 'Svi zahtevi',
      subtitle: 'Pregled i odobravanje zahteva za izmene vozila',
      pendingCount: '{{count}} zahtev(a) čeka odobrenje',
      noRequests: 'Nema zahteva',
      vehicle: 'Vozilo',
      type: 'Tip',
      field: 'Polje',
      oldValue: 'Stara vrednost',
      newValue: 'Nova vrednost',
      submittedBy: 'Podnosilac',
      date: 'Datum',
      status: 'Status',
      approve: 'Odobri',
      reject: 'Odbij',
    },
    vehicleRequests: {
      title: 'Zahtevi za vozila',
      subtitle: 'Pregled i upravljanje zahtevima za korišćenje vozila',
      create: 'Novi zahtev',
      add: 'Novi zahtev',
      details: 'Detalji zahteva',
      loading: 'Učitavanje zahteva...',
      notFound: 'Zahtev nije pronađen ili je došlo do greške pri učitavanju.',

      // Tabs
      tabs: {
        all: 'Svi zahtevi',
        allMine: 'Za vozila koja odobravam',
        my: 'Moji zahtevi',
        pending: 'Na čekanju',
        pendingMine: 'Na čekanju (za moje odobrenje)',
      },
      table: {
        notAssigned: 'Nije dodeljeno',
      },
      tooltips: {
        view: 'Pregledaj',
        approve: 'Odobri',
        reject: 'Odbij',
      },

      // Table columns
      columns: {
        vehicle: 'Vozilo',
        purpose: 'Svrha',
        period: 'Period',
        requester: 'Podnosilac',
        status: 'Status',
        actions: 'Akcije',
      },

      // Form
      form: {
        title: 'Novi zahtev za vozilo',
        subtitle: 'Popunite formu da biste zatražili vozilo za određenu svrhu',
        vehicleSelection: 'Odabir vozila',
        purposeSection: 'Svrha zahteva',
        periodSection: 'Period i destinacija',
        periodUsage: 'Period korišćenja',
        additionalInfo: 'Dodatne informacije',
        notesSection: 'Dodatne napomene',
        preselectedVehicle: 'Vozilo je već odabrano:',
        selectVehicle: 'Odaberite vozilo',
        vehicleOptional: 'Vozilo (opciono)',
        vehicleAssignableLater: 'Vozilo može biti dodeljeno kasnije od strane menadžera',
        requestForLabel: 'Zahtev u ime (opciono)',
        requestForSelf: 'Za sebe',
        requestForHint: 'Odabrani radnik će biti vozač na putnom nalogu nakon odobrenja',
        purposeRequired: 'Svrha *',
        purposeHint: 'Opišite svrhu korišćenja vozila (minimum 10 karaktera)',
        purposeHintShort: 'Opišite svrhu korišćenja vozila',
        purposePlaceholder: 'Npr. Službeno putovanje u Beograd - sastanak sa klijentom',
        purposePlaceholderShort: 'Npr. Službeno putovanje u Beograd',
        startDateRequired: 'Datum početka *',
        endDateRequired: 'Datum završetka *',
        startTime: 'Vreme početka',
        startTimeRequired: 'Vreme početka *',
        startTimeFormOptional: 'Vreme početka (opciono)',
        endTime: 'Vreme završetka',
        endTimeFormOptional: 'Vreme završetka (opciono)',
        timeRequiredToday: 'Obavezno kada je datum danas',
        timeOptional: 'Opciono',
        timeOptionalFullDay: 'Ostavite prazno za ceo dan',
        destinationOptional: 'Destinacija (opcionalno)',
        destinationPlaceholder: 'Npr. Beograd, Srbija',
        destinationPlaceholderShort: 'Npr. Beograd',
        estimatedKm: 'Procenjena km',
        estimatedKmLabel: 'Procenjena kilometraža (km)',
        estimatedDistancePlaceholder: 'Npr. 250',
        estimatedKmPlaceholderShort: 'Npr. 150',
        notesOptional: 'Napomene (opcionalno)',
        notesPlaceholder: 'Dodatne napomene ili zahtevi...',
        notesPlaceholderDialog: 'Dodatne informacije...',
        notesPlaceholderForm: 'Dodatne informacije o zahtevu...',
        editTitle: 'Izmeni zahtev za vozilo',
        saveChanges: 'Sačuvaj izmene',
        submit: 'Pošalji zahtev',
        submitting: 'Slanje...',
        submittingRequest: 'Slanje zahteva...',
      },

      // Fields
      fields: {
        vehicle: 'Vozilo',
        vehiclePlateNumber: 'Registarska oznaka',
        vehicleDescription: 'Opis vozila',
        requester: 'Podnosilac zahteva',
        createdBy: 'Zahtev podneo',
        purpose: 'Svrha',
        destination: 'Destinacija',
        estimatedDistance: 'Procenjena distanca',
        requestedStartDate: 'Datum početka',
        requestedEndDate: 'Datum završetka',
        startDate: 'Datum početka',
        endDate: 'Datum završetka',
        duration: 'Trajanje',
        notes: 'Napomene',
        status: 'Status',
        approver: 'Odobrio',
        approvalDate: 'Datum odobrenja',
        rejectionDate: 'Datum odbijanja',
        rejectionReason: 'Razlog odbijanja',
        cancellationDate: 'Datum otkazivanja',
        cancellationReason: 'Razlog otkazivanja',
        createdAt: 'Kreirano',
        travelOrder: 'Vožnja',
      },

      // Statuses
      statuses: {
        pending: 'Na čekanju',
        approved: 'Odobren',
        rejected: 'Odbijen',
        cancelled: 'Otkazan',
        completed: 'Završen',
      },

      // Sections
      sections: {
        summary: 'Pregled zahteva',
        details: 'Detalji zahteva',
        decision: 'Informacije o odluci',
        timeline: 'Vremenska linija',
      },

      // Actions
      actions: {
        approve: 'Odobri',
        reject: 'Odbij',
        cancel: 'Otkaži',
        view: 'Pregledaj',
        viewVehicle: 'Pogledaj vozilo',
      },

      // Dialogs
      dialogs: {
        approveTitle: 'Odobri zahtev za vozilo',
        approveMessage: 'Da li ste sigurni da želite da odobrite ovaj zahtev?',
        approveDetails: 'Detalji zahteva:',
        approveConfirm: 'Odobri zahtev',
        approveConfirming: 'Odobravanje...',
        approveSuccess: 'Zahtev je uspešno odobren',

        rejectTitle: 'Odbij zahtev za vozilo',
        rejectMessage: 'Molimo unesite razlog odbijanja zahteva.',
        rejectDetails: 'Detalji zahteva:',
        rejectReason: 'Razlog odbijanja',
        rejectReasonPlaceholder: 'Npr. Vozilo je već rezervisano za taj period...',
        rejectReasonHint: 'Minimalno 10 karaktera',
        rejectConfirm: 'Odbij zahtev',
        rejectConfirming: 'Odbijanje...',
        rejectSuccess: 'Zahtev je uspešno odbijen',

        cancelTitle: 'Otkaži zahtev za vozilo',
        cancelMessage: 'Molimo unesite razlog otkazivanja zahteva.',
        cancelDetails: 'Detalji zahteva:',
        cancelReason: 'Razlog otkazivanja',
        cancelReasonPlaceholder: 'Npr. Putovanje je otkazano zbog promena planova...',
        cancelReasonHint: 'Minimalno 10 karaktera',
        cancelConfirm: 'Otkaži zahtev',
        cancelConfirming: 'Otkazivanje...',
        cancelSuccess: 'Zahtev je uspešno otkazan',
        cancelDisabledTooltip: 'Odobreni zahtevi ne mogu biti otkazani. Molimo otkažite vožnju umesto toga.',

        assignTitle: 'Dodeli vozilo zahtevu',
        assignPurpose: 'Svrha zahteva:',
        assignAlreadyHasVehicle: 'Ovaj zahtev već ima dodeljeno vozilo. Odabirom novog vozila će se zameniti postojeće.',
        assignVehicleHelper: 'Prikazana su samo dostupna vozila',
        assignDriverPrefix: 'Vozač',
        assignFreeStatus: 'Slobodno',
        assignNoVehiclesAvailable: 'Nema dostupnih vozila za dodelu. Sva vozila su ili zauzeta ili van upotrebe.',
        assignError: 'Greška pri dodeli vozila. Pokušajte ponovo.',
        assignConfirm: 'Dodeli vozilo',
      },

      // Detail page
      detail: {
        title: 'Zahtev za vozilo',
        notYetAssigned: 'Vozilo još nije dodeljeno ovom zahtevu. Menadžer može dodeliti vozilo klikom na dugme "Dodeli vozilo".',
        changeVehicle: 'Promeni vozilo',
        assignVehicle: 'Dodeli vozilo',
        timeline: 'Vremenski tok',
        timelineApproved: 'Odobreno',
        timelineRejected: 'Odbijeno',
        timelineCancelled: 'Otkazano',
        timelineCompleted: 'Završeno',
        travelOrderLabel: 'Vožnja',
        showTravelOrder: 'Prikaži',
      },

      // Messages
      messages: {
        period: 'Period',
        days: 'dana',
        day: 'dan',
        km: 'km',
        travelOrderCreated: 'Vožnja je kreirana za ovaj zahtev. ID: {{id}}',
      },

      // Upozorenja o registraciji (ne blokiraju odobravanje)
      registrationWarning: {
        missing: 'Vozilo nema evidentiranu važeću registraciju. Zahtev možete odobriti, ali registraciju treba srediti pre polaska.',
        expiresBeforeEnd: 'Registracija vozila ističe {{validTo}}, pre kraja traženog perioda. Zahtev možete odobriti, ali registraciju treba obnoviti.',
        startsAfterStart: 'Registracija vozila važi tek od {{validFrom}}, posle početka traženog perioda. Zahtev možete odobriti, ali vozilo do tada nije registrovano.',
      },

      // Validation
      validation: {
        vehicleRequired: 'Vozilo je obavezno',
        purposeRequired: 'Svrha je obavezna',
        purposeMinLength: 'Svrha mora imati najmanje 10 karaktera',
        startDateRequired: 'Datum početka je obavezan',
        endDateRequired: 'Datum završetka je obavezan',
        startDateTodayOrFuture: 'Datum početka mora biti danas ili u budućnosti',
        endDateAfterStartDate: 'Datum završetka mora biti posle datuma početka',
        estimatedDistancePositive: 'Procenjena kilometraža mora biti pozitivan broj',
        reasonRequired: 'Razlog je obavezan',
        reasonMinLength: 'Razlog mora imati najmanje 10 karaktera',
        timeRequiredToday: 'Vreme je obavezno kada je datum danas',
        timeMustBeFuture: 'Vreme mora biti u budućnosti',
      },
    },
    registrations: {
      title: 'Registracije',
      subtitle: 'Pregled i upravljanje registracijama vozila',
      create: 'Nova registracija',
      createRegistration: 'Nova registracija',
      editRegistration: 'Izmeni registraciju',
      noRegistrations: 'Nema registracija',
      notFound: 'Registracija nije pronađena',
      loading: 'Učitavanje registracije...',
      costPending: 'Bez troškova',

      // Form sections
      generalInfo: 'Opšti podaci',
      costInfo: 'Podaci o troškovima',
      providerInfo: 'Informacije o dobavljaču',
      additionalInfo: 'Dodatne informacije',

      // Form fields
      fields: {
        vehicle: 'Vozilo',
        validFrom: 'Važi od',
        validTo: 'Važi do',
        registrationDate: 'Datum registracije',
        registrationExpiry: 'Istek registracije',
        registrationNumber: 'Broj saobraćajne',
        odometerReading: 'Kilometraža',
        cost: 'Trošak',
        invoiceNumber: 'Broj fakture',
        provider: 'Dobavljač',
        contract: 'Ugovor',
        customProviderName: 'Naziv dobavljača (ručni unos)',
        description: 'Opis',
        notes: 'Napomene',
        updateVehicleRegistration: 'Ažuriraj registraciju vozila',
      },

      // Placeholders
      notesPlaceholder: 'Opcione napomene o registraciji...',

      // Table columns
      columns: {
        vehiclePlate: 'Registarska oznaka',
        validFrom: 'Važi od',
        expiryDate: 'Datum isteka',
        cost: 'Trošak',
        provider: 'Dobavljač',
        status: 'Status',
      },

      // Filters
      filters: {
        vehicle: 'Vozilo',
        provider: 'Dobavljač',
        status: 'Status',
        dateFrom: 'Datum od',
        dateTo: 'Datum do',
      },

      // Detail page
      details: {
        basicInfo: 'Osnovni podaci',
        vehicleDetails: 'Detalji vozila',
        providerInfo: 'Informacije o dobavljaču/ugovoru',
        costDetails: 'Detalji troškova',
        notes: 'Napomene',
        vehiclePlate: 'Registarska oznaka',
        validFrom: 'Važi od',
        validTo: 'Važi do',
        registrationDate: 'Datum registracije',
        expiryDate: 'Datum isteka',
        status: 'Status',
        description: 'Opis',
        odometerReading: 'Kilometraža',
        registrationNumber: 'Broj saobraćajne',
        vehicleId: 'ID vozila',
        providerName: 'Naziv dobavljača',
        providerId: 'ID dobavljača',
        contractNumber: 'Broj ugovora',
        totalCost: 'Ukupan trošak',
        invoiceNumber: 'Broj fakture',
      },

      // Status labels
      status: {
        Valid: 'Važeća',
        ExpiringSoon: 'Ističe uskoro',
        Expired: 'Istekla',
        Unknown: 'Nepoznato',
      },

      // Actions
      actions: {
        view: 'Pregledaj',
        edit: 'Izmeni',
        delete: 'Obriši',
        create: 'Kreiraj',
      },

      // Dialogs
      deleteConfirmTitle: 'Potvrda brisanja registracije',
      deleteConfirmMessage: 'Da li ste sigurni da želite da obrišete registraciju: {{registrationInfo}}?',
      deleteSuccess: 'Registracija je uspešno obrisana',
      deleteError: 'Greška pri brisanju registracije',

      // Validation messages
      validation: {
        vehicleRequired: 'Vozilo je obavezno',
        validFromRequired: 'Datum početka važenja je obavezan',
        validToRequired: 'Datum isteka važenja je obavezan',
        odometerRequired: 'Kilometraža je obavezna',
        odometerNonNegative: 'Kilometraža ne može biti negativna',
        costRequired: 'Trošak je obavezan',
        costNonNegative: 'Trošak ne može biti negativan',
        descriptionRequired: 'Opis je obavezan',
        contractRequired: 'Ugovor je obavezan kada je odabran dobavljač',
      },

      // Success messages
      success: {
        created: 'Registracija je uspešno kreirana',
        updated: 'Registracija je uspešno ažurirana',
        deleted: 'Registracija je uspešno obrisana',
      },

      // Error messages
      errors: {
        createFailed: 'Greška pri kreiranju registracije',
        updateFailed: 'Greška pri ažuriranju registracije',
        deleteFailed: 'Greška pri brisanju registracije',
        loadFailed: 'Greška pri učitavanju registracije',
      },
    },
    fuelLogs: {
      title: 'Evidencija goriva',
      add: 'Dodaj unos goriva',
      edit: 'Izmeni unos goriva',
      withoutTravelOrder: 'Bez vožnje',
      viewTrip: 'Pogledaj vožnju',
      viewTravelOrder: 'Pogledaj putni nalog',
      sectionTrip: 'Vožnja',
      sectionTravelOrder: 'Putni nalog',
      tripNumber: 'Broj vožnje',
      travelOrderNumber: 'Broj putnog naloga',
      notLinked: 'Nije povezan',
      list: {
        title: 'Gorivo',
        subtitle: 'Pregled svih unosa goriva',
        searchPlaceholder: 'Pretraži po vozilu, stanici, putnom nalogu...',
        allTypes: 'Svi tipovi',
        emptyMessage: 'Nema unetih podataka o gorivu.',
        errorMessage: 'Greška pri učitavanju podataka o gorivu.',
        importButton: 'Uvoz iz Excel-a',
        filters: {
          vehicle: 'Vozilo',
          vehiclePlaceholder: 'Izaberite vozilo',
          fromDate: 'Od datuma',
          toDate: 'Do datuma',
          productType: 'Tip proizvoda',
          productTypePlaceholder: 'Izaberite tip proizvoda',
          fuelType: 'Tip goriva',
          fuelTypePlaceholder: 'Izaberite tip goriva',
        },
      },
      summary: {
        vehicleLifetime: 'Ukupno za vozilo',
        lifetimeSubtitle: 'Sve vreme',
        currentMonth: 'Tekući mesec',
        currentMonthFleet: 'Tekući mesec (cela flota)',
        filtered: 'Filtrirano',
        totalCost: 'Ukupni troškovi',
        totalLiters: 'Ukupno litara',
        count: 'Broj unosa',
        averageCost: 'Prosečan trošak',
      },
      table: {
        vehicle: 'Vozilo',
        travelOrder: 'Putni nalog',
        odometer: 'Kilometraža',
        pricePerLiter: 'Cena/L',
        total: 'Ukupno',
        station: 'Stanica',
        noOrder: 'Bez naloga',
        distance: 'Pređeno',
        consumption: 'Potrošnja',
      },
      consumption: {
        title: 'Analiza potrošnje',
        distance: 'Pređeno od prethodnog tankovanja',
        consumption: 'Potrošnja',
        status: 'Status',
        deviation: 'Odstupanje od reference',
        reference: 'Referentna potrošnja vozila',
        tolerance: 'Tolerancija',
        previousFuelLog: 'Prethodno tankovanje',
        viewPrevious: 'Otvori prethodno',
        notAvailable: 'Nije dostupno (prvo tankovanje, nedostaju podaci ili vozilo nema definisanu referentnu potrošnju).',
        noReference: 'Vozilo nema definisanu referentnu potrošnju, pa se status ne računa.',
        statuses: {
          Unknown: 'Nepoznato',
          Normal: 'U granicama',
          High: 'Povišena',
          Low: 'Niska',
        },
      },
      delete: {
        title: 'Potvrda brisanja',
        message: 'Da li ste sigurni da želite da obrišete unos goriva: {{info}}?',
      },
      fuelTypes: {
        Other: 'Ostalo',
        Diesel: 'Dizel',
        Petrol: 'Benzin',
        LPG: 'TNG',
        CNG: 'KPG',
        Electric: 'Električno',
      },
      productTypes: {
        Fuel: 'Gorivo',
        AdBlue: 'AdBlue',
        Other: 'Ostalo (nije gorivo)',
      },
      unitLabels: {
        Liter: 'Litar',
        Piece: 'Komad',
      },
      unitShort: {
        Liter: 'L',
        Piece: 'KOM',
      },
      detail: {
        title: 'Unos goriva - {{date}}',
        notFound: 'Unos goriva nije pronađen ili je došlo do greške pri učitavanju.',
        view: 'Pogledaj',
        sections: {
          basicInfo: 'Osnovni podaci',
          providerContract: 'Dobavljač i ugovor',
          additional: 'Dodatni detalji',
          entryInfo: 'Informacije o unosu',
        },
        fields: {
          odometer: 'Kilometraža',
          product: 'Proizvod',
          pricePerUnit: 'Cena po jedinici',
          totalCost: 'Ukupan trošak',
          provider: 'Dobavljač',
          contractNumber: 'Broj ugovora',
          addedBy: 'Uneo',
          addedAt: 'Datum unosa',
        },
      },
      fields: {
        vehicle: 'Vozilo',
        date: 'Datum',
        odometerReading: 'Stanje kilometraže',
        productType: 'Tip proizvoda',
        unit: 'Jedinica mere',
        fuelType: 'Tip goriva',
        liters: 'Litara',
        quantity: 'Količina',
        pricePerLiter: 'Cena po jedinici (RSD)',
        totalCost: 'Ukupan trošak (RSD)',
        product: 'Proizvod',
        productName: 'Naziv proizvoda',
        productSku: 'Šifra proizvoda',
        fuelStationName: 'Benzinska stanica',
        fuelStationCode: 'Šifra stanice',
        fuelCardNumber: 'Broj kartice',
        invoiceNumber: 'Broj fakture',
        fiscalReceiptNumber: 'Broj fiskalnog računa',
        deliveryNoteNumber: 'Broj otpremnice',
        notes: 'Napomene',
      },
      import: {
        title: 'Uvoz evidencije goriva',
        subtitle: 'Učitajte Excel izveštaj NIS kartice i unesite sve transakcije odjednom.',
        selectFile: 'Izaberi fajl',
        changeFile: 'Promeni fajl',
        noFileSelected: 'Nijedan fajl nije izabran.',
        previewButton: 'Analiziraj fajl',
        commitButton: 'Uvezi izabrane redove',
        back: 'Nazad',
        cancel: 'Odustani',
        close: 'Zatvori',
        fileAccept: 'Podržani formati: .xlsx',
        previewing: 'Analiza u toku…',
        committing: 'Uvoz u toku…',
        previewError: 'Greška pri analizi fajla. Proverite format i pokušajte ponovo.',
        commitError: 'Greška pri uvozu. Nijedan red nije sačuvan.',
        dropZoneHint: 'Prevucite Excel fajl ovde',
        invalidFileType: 'Dozvoljen je samo .xlsx fajl.',
        summary: {
          totalRows: 'Ukupno redova: {{count}}',
          new: 'Novi: {{count}}',
          warning: 'Upozorenja: {{count}}',
          duplicate: 'Duplikati: {{count}}',
          invalid: 'Nevalidni: {{count}}',
          totalCost: 'Ukupan trošak: {{amount}}',
          selected: 'Za uvoz: {{count}}',
        },
        statuses: {
          New: 'Novi',
          Warning: 'Upozorenje',
          Duplicate: 'Duplikat',
          Invalid: 'Nevalidan',
        },
        columns: {
          include: 'Uvezi',
          row: 'Red',
          status: 'Status',
          date: 'Datum',
          vehicle: 'Vozilo',
          product: 'Proizvod',
          quantity: 'Količina',
          unit: 'Jed.',
          totalCost: 'Ukupno',
          odometer: 'Kilometraža',
          travelOrder: 'Putni nalog',
        },
        messages: {
          emptyRows: 'Fajl ne sadrži nijedan red sa podacima.',
          includeDuplicateHint: 'Označite "Uvezi" da biste ažurirali postojeći red (override).',
          invalidCannotImport: 'Nevalidni redovi se ne mogu uvesti.',
          odometerRequired: 'Kilometraža je obavezna.',
          odometerRange: 'Dozvoljeno {{min}}–{{max}} km.',
          odometerMin: 'Najmanje {{min}} km.',
          odometerMax: 'Najviše {{max}} km.',
          odometerRequiredBlocking:
            'Ispravite kilometražu u {{count}} red(ova): {{rows}}.',
        },
        // Codes emitted by the backend FuelLogImportAnalyzer for per-row
        // validation / duplicate hints (see FuelLogImportMessageCodes.cs).
        messageCodes: {
          MissingDate: 'Nedostaje ili je neispravan datum.',
          MissingProductName: 'Nedostaje naziv proizvoda.',
          InvalidQuantity: 'Količina nedostaje ili nije pozitivna.',
          InvalidTotalCost: 'Ukupan trošak nedostaje ili nije pozitivan.',
          MissingUnit: 'Nedostaje jedinica mere.',
          MissingOdometer: 'Nedostaje kilometraža. Unesite je pre uvoza.',
          VehicleNotFound: 'Vozilo nije pronađeno po registraciji ili internom kodu.',
          UnknownUnit: 'Nepoznata jedinica mere „{{unit}}".',
          DuplicateMatch: 'Poklapa se sa postojećim unosom (isto vozilo/datum/vreme/proizvod/račun). Označite da prepišete.',
          UnknownProduct: 'Proizvod {{sku}} „{{name}}" nije u katalogu. Dodajte ga u katalog pa osvežite pregled.',
          UnitMismatch: 'Jedinica u fajlu ({{actual}}) se razlikuje od jedinice u katalogu ({{expected}}).',
        },
        unknownProducts: {
          alert: 'Redova sa proizvodom koji nije u katalogu: {{count}}. Dodajte proizvode u katalog, pa osvežite pregled; do tada se ti redovi ne uvoze.',
          addToCatalog: 'Dodaj u katalog',
          refresh: 'Osveži pregled',
        },
        duplicateFile: {
          warning: 'Ovaj fajl je već uvezen ({{fileName}}, {{importedAt}}, korisnik: {{importedBy}}, uvezeno redova: {{count}}). Ako nastavite, redovi prepoznati kao duplikati biće preskočeni; označite ih ručno ako želite da ažurirate postojeće zapise.',
        },
        result: {
          title: 'Uvoz završen',
          imported: 'Uvezeno novih: {{count}}',
          updated: 'Ažurirano postojećih: {{count}}',
          skipped: 'Preskočeno: {{count}}',
          invalid: 'Nevalidno: {{count}}',
        },
      },
      catalog: {
        menuItem: 'Katalog proizvoda',
        title: 'Katalog proizvoda goriva',
        subtitle: 'Proizvodi sa NIS kartice po šifri. Uvoz razvrstava redove isključivo preko ovog kataloga; nepoznata šifra zaustavlja red dok se proizvod ne doda.',
        searchPlaceholder: 'Pretraži po šifri ili nazivu',
        add: 'Dodaj proizvod',
        addTitle: 'Novi proizvod',
        editTitle: 'Izmena proizvoda',
        empty: 'Nema proizvoda.',
        note: 'Napomena',
        active: 'Aktivan',
        inactive: 'Neaktivan',
        skuHint: 'Šifra iz NIS izveštaja (kolona SIFRAROBA).',
        otherHint: 'Ulazi u trošak, ne ulazi u potrošnju goriva.',
        inactiveHint: 'Neaktivan proizvod se pri uvozu tretira kao nepoznat i ne nudi se pri izmeni unosa.',
      },
      validation: {
        vehicleRequired: 'Vozilo je obavezno',
        odometerInvalid: 'Unesite validnu vrednost',
        odometerMinimumValue: 'Kilometraža ne može biti 0',
        odometerMinimum: 'Kilometraža mora biti veća ili jednaka {{min}} km',
        odometerMaximum: 'Kilometraža ne može biti veća od {{max}} km',
      },
      warnings: {
        odometerBelowCurrent: 'Upozorenje: Uneta kilometraža ({{entered}} km) je manja od trenutne kilometraže vozila ({{current}} km). Ovo može biti u redu ako unosite istorijske podatke.',
        productNotInCatalog: 'Proizvod {{product}} nije u katalogu. Izaberite proizvod iz kataloga ili ga prvo dodajte u katalog.',
      },
      helpers: {
        product: 'Tip proizvoda, tip goriva i jedinica se preuzimaju iz kataloga.',
        odometerRange: 'Minimalno: {{min}} km',
        odometerRangeWithMax: 'Minimalno: {{min}} km, Maksimalno: {{max}} km',
        pricePerLiter: 'Opciono - ako unesete, ukupan trošak će biti automatski izračunat',
        totalCost: 'Obavezno - unesite ukupan trošak ili cenu po litri',
      },
    },
    fleetUsers: {
      title: 'Korisnici voznog parka',
      list: {
        title: 'Korisnici',
        subtitle: 'Pregled korisnika voznog parka',
      },
      detail: {
        title: 'Detalji korisnika',
      },
      create: {
        title: 'Novi korisnik',
        subtitle: 'Dodaj novog korisnika voznog parka',
      },
      edit: {
        title: 'Izmeni korisnika',
        subtitle: 'Izmeni podatke korisnika',
      },
      fields: {
        firstName: 'Ime',
        lastName: 'Prezime',
        email: 'Email',
        operationalUnit: 'Organizaciona jedinica',
        driverLicenseNumber: 'Broj vozačke dozvole',
        driverLicenseCategories: 'Kategorije',
        driverLicenseCategoriesHelper: 'Unesite kategorije odvojene zarezom (npr. B, C, D)',
        driverLicenseExpiryDate: 'Datum isteka',
        phoneNumber: 'Telefon',
      },
      tabs: {
        basicInfo: 'Osnovni podaci',
        driverInfo: 'Vozačka dozvola',
        requests: 'Zahtevi',
        travelOrders: 'Vožnje',
        unitAuthorizations: 'Ovlašćenja',
      },
      sections: {
        basicInfo: 'Osnovni podaci',
        driverLicense: 'Vozačka dozvola',
        contactInfo: 'Kontakt informacije',
      },
      unitAuthorizations: {
        title: 'Ovlašćenja po organizacionim jedinicama',
        subtitle:
          'Jedinice nad kojima korisnik ima dodatna ovlašćenja za rad, uključujući matičnu jedinicu.',
        showHistory: 'Prikaži istoriju',
        empty: 'Nema dodeljenih ovlašćenja',
        fields: {
          operationalUnit: 'Organizaciona jedinica',
          validFrom: 'Važi od',
          validTo: 'Važi do',
          reason: 'Razlog',
          grantedBy: 'Dodelio',
          status: 'Status',
          revocationReason: 'Razlog opoziva',
        },
        status: {
          active: 'Aktivno',
          revoked: 'Opozvano',
          expired: 'Isteklo',
        },
        grant: {
          action: 'Dodeli ovlašćenje',
          title: 'Dodela ovlašćenja',
          description:
            'Korisnik dobija pravo rada nad izabranom organizacionom jedinicom. Ako datumi nisu uneti, ovlašćenje važi trajno.',
          validFromHelper: 'Prazno = odmah',
          validToHelper: 'Prazno = bez roka',
          submit: 'Dodeli',
        },
        revoke: {
          action: 'Opozovi',
          title: 'Opoziv ovlašćenja',
          description: 'Ovlašćenje nad jedinicom {{unit}} će biti opozvano, ali ostaje u istoriji.',
          submit: 'Opozovi',
        },
      },
      noRequests: 'Nema zahteva',
      noTravelOrders: 'Nema vožnji',
      createSuccess: 'Korisnik uspešno kreiran',
      updateSuccess: 'Korisnik uspešno ažuriran',
      licenseExpiringSoon: 'Vozačka dozvola ističe uskoro',
      licenseExpired: 'Vozačka dozvola je istekla',
    },
    workOrders: {
      title: 'Radni nalozi',
      subtitle: 'Pregled i upravljanje radnim nalozima',
      create: 'Novi radni nalog',
      edit: 'Izmena radnog naloga',
      types: {
        Service: 'Servis',
        TireService: 'Vulkanizer',
      },
      statuses: {
        Draft: 'Nacrt',
        Issued: 'Izdat',
        Completed: 'Završen',
        Cancelled: 'Otkazan',
      },
      filters: {
        type: 'Tip',
        status: 'Status',
        search: 'Pretraga',
        searchPlaceholder: 'Broj, tablica, dobavljač...',
        allTypes: 'Svi tipovi',
        allStatuses: 'Svi statusi',
      },
      table: {
        number: 'Broj',
        type: 'Tip',
        status: 'Status',
        vehicle: 'Vozilo',
        provider: 'Dobavljač',
        createdOn: 'Datum kreiranja',
        issuedOn: 'Datum izdavanja',
        items: 'Stavke',
      },
      empty: {
        default: 'Nema radnih naloga',
        filtered: 'Nema rezultata sa trenutnim filterima',
      },
      errors: {
        loadFailed: 'Greška pri učitavanju radnih naloga. Pokušajte ponovo.',
        notFound: 'Radni nalog nije pronađen ili je došlo do greške pri učitavanju.',
      },
      actions: {
        complete: 'Završi nalog',
        delete: 'Obriši nalog',
        downloadPdf: 'Preuzmi PDF',
        generatingPdf: 'Generisanje PDF...',
        createService: 'Kreiraj servis',
        createTireService: 'Kreiraj vulkanizerski servis',
        completeDisabledHint: 'Radni nalog se može završiti samo ako ima servis ili je označen kao reklamacija.',
      },
      service: {
        createTitle: 'Novi servis za radni nalog',
        createTitleWithNumber: 'Novi servis za radni nalog {{number}}',
        contextSection: 'Podaci iz radnog naloga',
        cannotAttachComplaint: 'Radni nalog je označen kao reklamacija i ne može imati servis.',
        alreadyHasService: 'Radni nalog već ima povezan servis.',
        notIssued: 'Servis se može kreirati samo za izdate radne naloge.',
      },
      tireService: {
        createTitle: 'Novi vulkanizerski servis za radni nalog',
        createTitleWithNumber: 'Novi vulkanizerski servis za radni nalog {{number}}',
      },
      dialogs: {
        deleteTitle: 'Obriši radni nalog',
        deleteMessage: 'Da li ste sigurni da želite da trajno obrišete ovaj radni nalog? Ova akcija se ne može poništiti.',
        completeTitle: 'Završi radni nalog',
        completeMessage: 'Da li ste sigurni da želite da označite ovaj radni nalog kao završen?',
        completing: 'Završavanje...',
        confirmComplete: 'Završi',
      },
      detail: {
        titleWithNumber: 'Radni nalog {{number}}',
        titleDraft: 'Nacrt radnog naloga',
        vehicleSection: 'Vozilo',
        providerSection: 'Dobavljač / Ugovor',
        vehicleStateSection: 'Stanje vozila i oprema',
        equipmentSubtitle: 'Oprema na vozilu',
        workItemsSection: 'Stavke rada',
        noItems: 'Nema stavki',
        vulcanizerSection: 'Usluge vulkanizera',
        noServices: 'Nema usluga',
        notesSection: 'Napomene',
        metadataSection: 'Podaci o nalogu',
        attachedServiceTitle: 'Povezan servis',
        attachedServiceSubtitle: 'Broj servisa: {{number}}',
        attachedServiceSubtitleNoNumber: 'Servis je povezan sa ovim radnim nalogom.',
        viewService: 'Otvori servis',
        itemCount: '{{count}} stavki',
        table: {
          ordinal: '#',
          description: 'Opis',
          notes: 'Napomena',
          rowNum: 'R.br.',
          serviceName: 'Naziv usluge',
          quantity: 'Količina',
        },
        fields: {
          internalCode: 'Interna oznaka',
          brandModel: 'Marka / Model',
          plateNumber: 'Registarska oznaka',
          odometer: 'Stanje kilometraže',
          orderType: 'Tip naloga',
          providerName: 'Naziv dobavljača',
          contractNumber: 'Broj ugovora',
          contractValidity: 'Važnost ugovora',
          fuelLevel: 'Nivo goriva',
          damageNotes: 'Oštećenja na vozilu',
          createdBy: 'Kreirao',
          createdOn: 'Datum kreiranja',
          issuedOn: 'Datum izdavanja',
          completedOn: 'Datum završetka',
          cancelledOn: 'Datum otkazivanja',
          cancellationReason: 'Razlog otkazivanja',
        },
      },
      form: {
        basicInfo: 'Osnovni podaci',
        providerSection: 'Dobavljač i ugovor',
        vehicleStateSection: 'Stanje vozila',
        equipmentSection: 'Oprema na vozilu',
        notesSection: 'Napomene',
        vulcanizerSection: 'Usluge vulkanizera',
        workItemsSection: 'Stavke rada',
        noServices: 'Nema usluga',
        noActiveContracts: 'Nema aktivnih ugovora',
        noTireContracts: 'Nema aktivnih ugovora za vulkanizerske usluge za ovog dobavljača',
        selectProviderFirst: 'Prvo izaberite dobavljača',
        addEquipment: 'Dodaj opremu',
        removeEquipment: 'Ukloni',
        addItem: 'Dodaj stavku',
        removeItem: 'Ukloni stavku',
        addService: 'Dodaj uslugu',
        removeService: 'Ukloni uslugu',
        notesPlaceholder: 'Unesite napomene...',
        equipmentNamePlaceholder: 'Naziv opreme',
        fields: {
          type: 'Tip naloga',
          vehicle: 'Vozilo',
          provider: 'Dobavljač',
          contract: 'Ugovor',
          odometer: 'Stanje kilometraže (km)',
          fuelLevel: 'Nivo goriva (%)',
          damageNotes: 'Oštećenja na vozilu',
          damageNotesPlaceholder: 'Opišite oštećenja na vozilu...',
          itemDescription: 'Opis stavke {{number}}',
          itemNote: 'Napomena',
        },
      },
      validation: {
        vehicleRequired: 'Vozilo je obavezno',
        providerRequired: 'Dobavljač je obavezan',
        contractRequired: 'Ugovor je obavezan',
        odometerRequired: 'Stanje kilometraže je obavezno',
        odometerPositive: 'Stanje kilometraže mora biti veće od 0',
        fuelLevelRange: 'Nivo goriva mora biti između 0 i 100',
        itemRequired: 'Bar jedna stavka sa opisom je obavezna',
        serviceRequired: 'Bar jedna usluga sa nazivom je obavezna',
      },
    },
    operationalUnits: {
      title: 'Organizacione jedinice',
      create: 'Nova jedinica',
      createTitle: 'Nova organizaciona jedinica',
      edit: 'Izmeni organizacionu jedinicu',
      searchPlaceholder: 'Pretraži jedinice...',
      table: {
        name: 'Naziv',
        sapCode: 'SAP šifra',
        cityPrefix: 'Prefiks grada',
        status: 'Status',
      },
      empty: {
        default: 'Nema organizacionih jedinica.',
        filtered: 'Nema rezultata pretrage.',
      },
      status: {
        active: 'Aktivno',
        archived: 'Arhivirano',
      },
      fields: {
        name: 'Naziv',
        sapCode: 'SAP šifra',
        cityPrefix: 'Prefiks grada',
        cityPrefixHint: 'Npr. NS, BG, PA, ZR, KI',
      },
    },
  },
  users: {
    nav: {
      users: 'Korisnici',
      employeeAccounts: 'Nalozi zaposlenih',
      roles: 'Uloge',
      permissions: 'Permisije',
    },
    list: {
      title: 'Korisnici',
      subtitle: 'Upravljanje korisnicima sistema',
      addUser: 'Dodaj korisnika',
      search: 'Pretraga',
      searchPlaceholder: 'Ime, prezime ili email',
      allRoles: 'Sve uloge',
      active: 'Aktivni',
      archived: 'Arhivirani',
      archiveConfirm: 'Da li ste sigurni da želite da arhivirate korisnika {{name}}?',
      restoreConfirm: 'Da li ste sigurni da želite da vratite korisnika {{name}} iz arhive?',
      table: {
        firstName: 'Ime',
        lastName: 'Prezime',
        email: 'Email',
        role: 'Uloga',
        roles: 'Uloge',
        status: 'Status',
        actions: 'Akcije',
      },
      statuses: {
        active: 'Aktivno',
        archived: 'Arhivirano',
      },
      actions: {
        edit: 'Izmeni',
        archive: 'Arhiviraj',
        restore: 'Vrati',
      },
    },
    form: {
      createTitle: 'Novi korisnik',
      editTitle: 'Izmeni korisnika',
      basicInfo: 'Osnovni podaci',
      email: 'Email',
      firstName: 'Ime',
      lastName: 'Prezime',
      roles: 'Uloge',
      emailPlaceholder: 'korisnik@example.com',
      firstNamePlaceholder: 'Ime',
      lastNamePlaceholder: 'Prezime',
      rolesHelper: 'Izaberite jednu ili više uloga za korisnika',
      rolesReadonlyHelper: 'Uloge može menjati samo ovlašćeni korisnik',
      newUserInfo: 'Korisnik će dobiti email sa linkom za postavljanje lozinke.',
      create: 'Kreiraj',
      save: 'Sačuvaj',
      cancel: 'Otkaži',
      validation: {
        required: 'Ovo polje je obavezno',
        invalidEmail: 'Unesite validnu email adresu',
        roleRequired: 'Izaberite bar jednu ulogu',
        requiredFields: 'Popunite sva obavezna polja',
      },
    },
    employeeAccounts: {
      title: 'Nalozi zaposlenih',
      subtitle: 'Pregled zaposlenih i njihovih korisničkih naloga',
      search: 'Pretraga',
      searchPlaceholder: 'Ime, email, radna jedinica ili radno mesto',
      table: {
        employee: 'Zaposleni',
        businessEmail: 'Poslovni email',
        workUnitAndPosition: 'Radna jedinica / mesto',
        accountStatus: 'Status naloga',
        roles: 'Uloge',
        actions: 'Akcije',
      },
      statuses: {
        hasAccount: 'Ima nalog',
        accountArchived: 'Nalog arhiviran',
        missingBusinessEmail: 'Nema poslovni email',
        emailAlreadyUsed: 'Email već koristi nalog',
        noAccount: 'Nema nalog',
      },
      blockingReasons: {
        missingBusinessEmail: 'Nema poslovni email',
        emailAlreadyUsed: 'Poslovni email već koristi drugi korisnički nalog',
      },
      actions: {
        createAccount: 'Kreiraj nalog',
        openUser: 'Otvori korisnika',
      },
      createDialog: {
        title: 'Kreiraj nalog zaposlenom',
        roles: 'Uloge',
        rolesHelper: 'Izaberite jednu ili više uloga za korisnika',
        cancel: 'Otkaži',
        create: 'Kreiraj nalog',
        creating: 'Kreiranje...',
      },
    },
    roles: {
      title: 'Uloge',
      subtitle: 'Kreiranje uloga i upravljanje permisijama koje uloga nosi',
      add: 'Nova uloga',
      listTitle: 'Uloge u sistemu',
      permissionsTitle: 'Permisije role',
      role: 'Uloga',
      type: 'Tip',
      system: 'Sistemska',
      custom: 'Korisnička',
      permissionsCount: 'Permisije',
      usersCount: 'Korisnici',
      selectRole: 'Izaberite ulogu za uređivanje permisija',
      editPermissions: 'Permisije',
      savePermissions: 'Sačuvaj permisije',
      permissionSelectionHelp: 'Permisije su grupisane po modulima. Otvorite modul i označite dozvole koje ova rola treba da ima.',
      permissionsSaved: 'Permisije role su sačuvane',
      created: 'Uloga je kreirana',
      systemHelp: 'Ovo je sistemska uloga. Izmene utiču na sve korisnike koji je imaju.',
      createDialog: {
        title: 'Nova uloga',
        name: 'Naziv uloge',
        nameHelp: 'Unesite jasan naziv role, npr. Dispečer ili Operater logistike. Maksimalno 50 karaktera.',
      },
    },
    permissions: {
      title: 'Permisije',
      subtitle: 'Pregled sistemskih permisija. Permisije se ne kreiraju niti brišu kroz UI.',
      catalog: 'Katalog permisija',
      search: 'Pretraga',
      module: 'Modul',
      resource: 'Resurs',
      action: 'Akcija',
      code: 'Kod',
      roles: 'Uloge',
      modules: {
        Fleet: 'Vozni park',
        Users: 'Korisnici',
        HumanResources: 'Kadrovska',
        Hr: 'Kadrovski katalozi',
        Documents: 'Dokumenti',
      },
      actions: {
        Read: 'Pregled',
        Create: 'Kreiranje',
        Update: 'Izmena',
        Delete: 'Brisanje',
        Archive: 'Arhiviranje',
        Restore: 'Vraćanje',
        Manage: 'Upravljanje',
        Assign: 'Dodela',
        Approve: 'Odobravanje',
        Reject: 'Odbijanje',
        Close: 'Zatvaranje',
        Open: 'Otvaranje',
        Run: 'Pokretanje',
        Import: 'Uvoz',
      },
    },
    access: {
      title: 'Pristup korisnika',
      subtitle: 'Uloge i direktne permisije korisnika',
      save: 'Sačuvaj pristup',
      saved: 'Pristup korisnika je sačuvan',
      roles: 'Uloge',
      directPermissions: 'Direktne permisije',
      directPermissionsHelp: 'Direktne permisije koristite samo za izuzetke. Permisije iz uloga su prikazane posebno.',
      fromRole: 'iz uloge',
      direct: 'direktno',
    },
  },
  // humanResources slice lives in modules/humanResources/i18n/sr-Latn.ts and
  // is deep-merged into this namespace by app/i18n/index.ts at startup.
  assignments: {
    warnings: {
      vehicleAlreadyAssigned: 'Upozorenje: Vozilo je trenutno dodeljeno korisniku {{userName}}. Nova dodela će automatski završiti trenutnu dodelu.',
      vehicleNotFree: 'Vozilo ne može biti dodeljeno jer trenutni status nije Slobodno ili U upotrebi. Trenutni status: {{status}}',
      activeTravelOrders: 'Vozilo je trenutno na vožnji. Dodela vozača se može promeniti tek kada se vožnja završi.',
    },
    dialog: {
      title: 'Dodeli vozilo {{plate}}',
      user: 'Korisnik *',
      advancedOptions: 'Napredne opcije',
      contractNumber: 'Broj ugovora (opciono)',
      notes: 'Napomene (opciono)',
      cancel: 'Odustani',
      assign: 'Dodeli',
      transferPeriodHolder: 'Prenesi i nosioca otvorenog putnog naloga',
    },
    types: {
      Permanent: 'Stalna',
      LongTerm: 'Dugoročna',
      Temporary: 'Privremena',
    },
  },
  vehicleBlocks: {
    create: { title: 'Nova nedostupnost' },
    update: { title: 'Izmeni nedostupnost' },
    close: { title: 'Zatvori nedostupnost' },
    delete: { title: 'Obriši nedostupnost' },
    fields: {
      blockType: 'Tip nedostupnosti',
      startDate: 'Datum početka',
      startTime: 'Vreme početka',
      endDate: 'Datum završetka',
      endTime: 'Vreme završetka',
      reason: 'Razlog',
      closedAt: 'Datum zatvaranja',
    },
    helpers: {
      optional: 'Opciono',
      endDateEmpty: 'Ostavite prazno za trajnu nedostupnost',
    },
    validation: {
      startDateRequired: 'Datum početka je obavezan',
      reasonRequired: 'Razlog je obavezan',
      endDateAfterStart: 'Datum završetka mora biti nakon datuma početka',
      closeDateRequired: 'Datum zatvaranja je obavezan',
      closeDateAfterStart: 'Datum zatvaranja mora biti nakon datuma početka',
    },
    errors: {
      create: 'Greška prilikom kreiranja nedostupnosti',
      update: 'Greška prilikom ažuriranja nedostupnosti',
      close: 'Greška prilikom zatvaranja nedostupnosti',
      delete: 'Greška prilikom brisanja nedostupnosti',
    },
    actions: {
      cancel: 'Otkaži',
      create: 'Kreiraj',
      creating: 'Kreiranje...',
      save: 'Sačuvaj',
      saving: 'Čuvanje...',
      close: 'Zatvori nedostupnost',
      closing: 'Zatvaranje...',
      delete: 'Obriši',
      deleting: 'Brisanje...',
    },
    confirm: {
      close: 'Da li ste sigurni da želite da zatvorite ovu nedostupnost?',
      delete: 'Da li ste sigurni da želite da obrišete ovu nedostupnost? Ova akcija se ne može poništiti.',
    },
    summary: {
      type: 'Tip',
      reason: 'Razlog',
      start: 'Početak',
      end: 'Kraj',
    },
    types: {
      Service: 'Na servisu',
      OutOfService: 'Van upotrebe',
      Manual: 'Ručna blokada',
    },
    list: {
      empty: 'Nema nedostupnosti za ovo vozilo.',
      active: 'Aktivna',
      inProgress: 'U toku...',
      createdBy: 'Kreirao',
      tooltips: {
        edit: 'Izmeni',
        close: 'Zatvori nedostupnost',
        delete: 'Obriši',
      },
    },
  },
  account: {
    title: 'Moj nalog',
    subtitle: 'Upravljanje nalogom i lozinkom',
    profile: 'Profil',
    userInformation: 'Informacije o korisniku',
    firstName: 'Ime',
    lastName: 'Prezime',
    email: 'Email',
    changePassword: 'Promeni lozinku',
    passwordSection: 'Promena lozinke',
    currentPassword: 'Trenutna lozinka',
    newPassword: 'Nova lozinka',
    confirmPassword: 'Potvrdi lozinku',
    passwordChanged: 'Lozinka je uspešno promenjena',
    passwordChangeFailed: 'Greška pri promeni lozinke',
    invalidCurrentPassword: 'Trenutna lozinka nije ispravna',
    passwordsDoNotMatch: 'Lozinke se ne poklapaju',
    passwordTooShort: 'Lozinka mora imati najmanje 8 karaktera',
    changePasswordButton: 'Promeni lozinku',
    changingPassword: 'Promena lozinke...',
  },
  apiErrors: {
    // Identity provider (Keycloak) errors on user registration
    'Identity.EmailIsNotUnique': 'Korisnik sa ovom e-mail adresom već postoji u sistemu za prijavu.',
    'Identity.RegistrationRejected':
      'Sistem za prijavu je odbio registraciju: podaci korisnika ili privremena lozinka ne zadovoljavaju politiku lozinki.',
    'Identity.RegistrationFailed': 'Korisnik nije mogao da bude registrovan u sistemu za prijavu. Pokušajte ponovo kasnije.',
    // Travel Order Period errors
    'TravelOrderPeriod.NotFoundForMonth':
      'Putni nalog za vozilo {{vehiclePlate}} u periodu {{period}} nije kreiran. Molimo kreirajte putni nalog pre odobravanja zahteva.',
    'TravelOrderPeriod.NotFound': 'Putni nalog nije pronađen.',
    'TravelOrderPeriod.InvalidVehicleId': 'ID vozila je obavezan.',
    'TravelOrderPeriod.InvalidResponsibleEmployeeId': 'ID odgovornog zaposlenog je obavezan.',
    'TravelOrderPeriod.InvalidMonth': 'Mesec mora biti između 1 i 12.',
    'TravelOrderPeriod.TravelOrderNumberRequired': 'Broj putnog naloga je obavezan.',
    'TravelOrderPeriod.PeriodAlreadyExists': 'Period putnog naloga već postoji za ovo vozilo i mesec.',
    'TravelOrderPeriod.PeriodNotOpen': 'Period putnog naloga nije otvoren za dodavanje novih vožnji.',
    'TravelOrderPeriod.OverlappingPeriod': 'Period se preklapa sa postojećim periodom za ovo vozilo.',
    'TravelOrderPeriod.VehicleAlreadyHasOpenPeriod': 'Nije moguće kreirati novi period jer vozilo već ima otvoren period. Zatvorite postojeći period prvo.',
    'TravelOrderPeriod.PeriodVehicleMismatch': 'Odabrani period ne pripada ovom vozilu.',
    'TravelOrderPeriod.HasActiveTrips': 'Nije moguće zatvoriti period dok postoje aktivne vožnje.',
    'TravelOrderPeriod.HasNonClosedTrips': 'Nije moguće zatvoriti period dok postoje nezatvorene vožnje. Sve vožnje moraju biti zatvorene ili otkazane.',
    'TravelOrderPeriod.HasOpenOrCompletedTrips': 'Sve vožnje moraju biti zatvorene ili otkazane pre zatvaranja perioda.',
    'TravelOrderPeriod.InProgressTripWithoutNextSegment': 'Vožnja u toku nema nastavak u sledećem periodu. Završite je ili otkažite.',
    'TravelOrderPeriod.CannotCloseBeforeMonthEnds': 'Period se može zatvoriti samo nakon poslednjeg dana meseca.',
    'TravelOrderPeriod.CannotCloseInCurrentStatus': 'Period može biti zatvoren samo kada je otvoren.',
    'TravelOrderPeriod.CannotCancelInCurrentStatus': 'Period može biti otkazan samo kada je otvoren.',
    'TravelOrderPeriod.CancellationReasonRequired': 'Razlog otkazivanja je obavezan.',
    'TravelOrderPeriod.CannotModifyClosedPeriod': 'Nije moguće izmeniti zatvoreni ili otkazani period.',
    'TravelOrderPeriod.RequestCrossesMonthBoundary': 'Datumi zahteva moraju biti unutar jednog kalendarskog meseca.',
    'TravelOrderPeriod.RequestOutsidePeriod': 'Datumi zahteva su izvan granica perioda.',
    'TravelOrderPeriod.EndDateMustBeAfterStartDate': 'Datum završetka mora biti nakon datuma početka.',
    'TravelOrderPeriod.CannotSetEndDateOnNonOpenEndedPeriod': 'Nije moguće postaviti datum završetka na period koji nije otvorenog tipa.',
    'TravelOrderPeriod.StartDateRequired': 'Datum početka je obavezan za otvorene periode.',
    'TravelOrderPeriod.InvalidOdometer': 'Stanje kilometraže mora biti pozitivna vrednost.',
    'TravelOrderPeriod.EndOdometerLessThanStart': 'Završna kilometraža ne može biti manja od početne.',
    'TravelOrderPeriod.StartOdometerGreaterThanEnd': 'Početna kilometraža ne može biti veća od završne.',
    'TravelOrderPeriod.CannotModifyDatesOnMonthlyPeriod': 'Nije moguće izmeniti datume na mesečnom periodu.',
    'TravelOrderPeriod.CannotReopenInCurrentStatus': 'Samo zatvoreni periodi mogu biti ponovo otvoreni.',
    'TravelOrderPeriod.CannotReopenOverlappingPeriod': 'Nije moguće ponovo otvoriti period jer postoji drugi aktivni period za isti vremenski raspon.',
    'TravelOrderPeriod.CannotModifyCancelledPeriod': 'Nije moguće izmeniti otkazani period.',
    'TravelOrderPeriod.NotAuthorizedForUnit': 'Nemate ovlašćenje nad jedinicom ovog vozila.',
    'TravelOrderPeriod.NotAuthorizedToChangeResponsibleEmployee': 'Nosioca putnog naloga menja samo menadžer putnih naloga za jedinicu vozila.',
    'TravelOrderPeriod.InvalidOperationalUnitId': 'Jedinica putnog naloga je obavezna.',
    'TravelOrderPeriod.SameResponsibleEmployee': 'Izabrani zaposleni je već nosilac ovog putnog naloga.',
    'TravelOrderPeriod.InvalidInitialStatus': 'Putni nalog se može kreirati samo sa statusom Otvoren.',
    'TravelOrderPeriod.CannotCreatePastPeriod': 'Nije moguće kreirati putni nalog za protekli mesec. Dozvoljeni su samo tekući i budući meseci.',
    'TravelOrderPeriod.NotAuthorizedToEnterOdometer': 'Kilometražu na putni nalog može uneti samo nosilac naloga ili menadžer putnih naloga za jedinicu vozila.',
    'TravelOrderPeriod.OdometerChangeReasonRequired': 'Razlog je obavezan pri izmeni već unete završne kilometraže.',
    'TravelOrderPeriod.OdometerOverrideReasonRequired': 'Razlog je obavezan kada se nalog zatvara sa krajnjom kilometražom koja se razlikuje od već unete.',
    'TravelOrderPeriod.HasOdometerConflicts': 'Putni nalog ima vožnje sa odstupanjem kilometraže. Ispravite ih pre zatvaranja.',
    'TravelOrderPeriod.StartOdometerDerivedFromPreviousPeriod': 'Početno stanje se ne može menjati jer se preuzima iz krajnjeg stanja prethodnog putnog naloga vozila. Ispravite krajnje stanje tog naloga.',
    'TravelOrderPeriod.StartOdometerAboveFirstReading': 'Početno stanje ne može biti veće od prvog evidentiranog očitavanja kilometraže vozila.',
    'TravelOrderPeriod.NotAuthorizedToEditStartOdometer': 'Početno stanje može da menja samo nosilac prvog putnog naloga vozila ili menadžer putnih naloga za jedinicu vozila.',

    // Vehicle Request errors
    'VehicleRequest.NotFound': 'Zahtev za vozilo nije pronađen.',
    'VehicleRequest.InvalidVehicleId': 'ID vozila je obavezan.',
    'VehicleRequest.InvalidRequesterId': 'ID podnosioca zahteva je obavezan.',
    'VehicleRequest.PurposeRequired': 'Svrha je obavezna za zahtev za vozilo.',
    'VehicleRequest.InvalidDateRange': 'Datum završetka mora biti nakon datuma početka.',
    'VehicleRequest.StartDateInPast': 'Datum početka ne može biti u prošlosti.',
    'VehicleRequest.VehicleNotAvailable': 'Vozilo nije dostupno za traženi period.',
    'VehicleRequest.AlreadyApproved': 'Zahtev je već odobren.',
    'VehicleRequest.AlreadyRejected': 'Zahtev je već odbijen.',
    'VehicleRequest.AlreadyCancelled': 'Zahtev je već otkazan.',
    'VehicleRequest.CannotApproveNonPending': 'Samo zahtevi na čekanju mogu biti odobreni.',
    'VehicleRequest.CannotRejectNonPending': 'Samo zahtevi na čekanju mogu biti odbijeni.',
    'VehicleRequest.CannotCancelInCurrentStatus': 'Zahtev ne može biti otkazan u trenutnom statusu.',
    'VehicleRequest.CannotCancelApprovedRequest': 'Odobreni zahtevi ne mogu biti otkazani. Molimo otkažite vožnju umesto toga.',
    'VehicleRequest.CannotCancelActiveTripRequest':
      'Nije moguće otkazati zahtev jer je vožnja već u toku ili završena.',
    'VehicleRequest.OverlappingRequest': 'Postoji preklapajući odobren zahtev za ovo vozilo.',
    'VehicleRequest.InvalidApproverId': 'Nevažeći ID odobravača.',
    'VehicleRequest.RejectionReasonRequired': 'Razlog odbijanja je obavezan.',
    'VehicleRequest.CannotLinkTravelOrderToNonApproved': 'Vožnja može biti povezana samo sa odobrenim zahtevima.',
    'VehicleRequest.CannotCompleteNonApproved': 'Samo odobreni zahtevi mogu biti označeni kao završeni.',
    'VehicleRequest.VehicleAssignedToAnotherDriver': 'Ovo vozilo je dodeljeno drugom vozaču. Samo dodeljeni vozač ili menadžeri voznog parka mogu ga zahtevati.',
    'VehicleRequest.VehicleReservationFailed': 'Greška pri rezervaciji vozila tokom procesa odobravanja.',
    'VehicleRequest.TravelOrderCreationFailed': 'Greška pri kreiranju vožnje.',
    'VehicleRequest.VehicleNotAssigned': 'Vozilo mora biti dodeljeno pre nego što zahtev može biti odobren.',
    'VehicleRequest.CannotAssignVehicleToNonPending': 'Vozilo može biti dodeljeno samo zahtevima na čekanju.',
    'VehicleRequest.VehiclePlateNumberRequired': 'Registarska oznaka vozila je obavezna pri dodeli vozila.',
    'VehicleRequest.VehicleDescriptionRequired': 'Opis vozila je obavezan pri dodeli vozila.',
    'VehicleRequest.Forbidden': 'Nemate dozvolu za pristup ovom zahtevu za vozilo.',
    'VehicleRequest.NotAuthorizedForVehicle': 'Nemate ovlašćenje za delovanje na zahtevima za ovo vozilo.',
    'VehicleRequest.NotAuthorizedToCreateForOthers': 'Nemate dozvolu za podnošenje zahteva u tuđe ime.',

    // Travel Order errors
    'TravelOrder.NotFound': 'Vožnja nije pronađena.',
    'TravelOrder.NotFoundByOrderNumber': 'Vožnja sa navedenim brojem nije pronađena.',
    'TravelOrder.RequestNotApproved': 'Vožnja može biti kreirana samo iz odobrenih zahteva.',
    'TravelOrder.TravelOrderNumberRequired': 'Broj vožnje je obavezan.',
    'TravelOrder.VehicleAlreadyInUse': 'Vozilo je već u upotrebi na drugoj vožnji.',
    'TravelOrder.CannotStartInCurrentStatus': 'Vožnja ne može biti pokrenuta u trenutnom statusu.',
    'TravelOrder.CannotEndInCurrentStatus': 'Vožnja ne može biti završena u trenutnom statusu.',
    'TravelOrder.EndOdometerLessThanStart': 'Završna kilometraža ne može biti manja od početne.',
    'TravelOrder.CannotCloseInCurrentStatus': 'Vožnja može biti zatvorena samo kada je završena.',
    'TravelOrder.CannotCancelInCurrentStatus': 'Vožnja može biti otkazana samo kada je otvorena.',
    'TravelOrder.CannotAddFuelLogInCurrentStatus': 'Evidencija goriva može biti dodana samo na vožnje u toku, završene ili zatvorene vožnje.',
    'TravelOrder.CancellationReasonRequired': 'Razlog otkazivanja je obavezan.',
    'TravelOrder.InvalidVehicleId': 'ID vozila je obavezan.',
    'TravelOrder.InvalidDriverId': 'ID vozača je obavezan.',
    'TravelOrder.InvalidOdometer': 'Stanje kilometraže mora biti pozitivna vrednost.',
    'TravelOrder.VehicleNotAssigned': 'Nije moguće kreirati vožnju bez dodeljenog vozila.',
    'TravelOrder.OverlappingTravelOrder': 'Nije moguće kreirati vožnju jer već postoji aktivna vožnja za ovo vozilo u traženom periodu.',
    'TravelOrder.CannotUpdateInCurrentStatus': 'Detalji vožnje mogu biti ažurirani samo kada je otvorena (nije još pokrenuta).',
    'TravelOrder.PeriodIdRequired': 'ID perioda putnog naloga je obavezan.',
    'TravelOrder.InvalidTripNumber': 'Broj vožnje mora biti pozitivan ceo broj.',
    'TravelOrder.NotAuthorized': 'Nemate dozvolu za ovu akciju na vožnji.',
    'TravelOrder.HolderCanOnlyAddOwnTrips': 'Nosilac putnog naloga može da doda samo vožnju u kojoj je sam vozač. Vožnju za drugog vozača podnesite kao zahtev za vozilo.',
    'TravelOrder.Forbidden': 'Nemate dozvolu za pristup ovoj vožnji.',
    'TravelOrder.StartDateInPast': 'Datum i vreme početka ne mogu biti u prošlosti.',
    'TravelOrder.EndDateBeforeStartDate': 'Datum završetka mora biti nakon datuma početka.',
    'TravelOrder.CurrentUserIdRequired': 'ID trenutnog korisnika je obavezan.',
    'TravelOrder.DestinationTooLong': 'Relacija može imati najviše 200 karaktera.',
    'TravelOrder.PurposeTooLong': 'Svrha može imati najviše 500 karaktera.',
    'TravelOrder.OdometerCorrectionValueRequired': 'Unesite bar jednu vrednost kilometraže (početnu ili završnu).',
    'TravelOrder.CannotCorrectOdometerInCurrentStatus': 'Kilometraža vožnje može se ispraviti tek kada je vožnja započeta i samo ako nije otkazana.',
    'TravelOrder.EndOdometerCorrectionRequiresEndedTrip': 'Završna kilometraža može se ispraviti tek kada je vožnja završena.',
    'TravelOrder.NotAuthorizedToCorrectOdometer': 'Kilometražu vožnje može ispraviti samo vozač dok vožnja nije zatvorena ili menadžer vožnji za jedinicu vozila.',
    'TravelOrder.OdometerCorrectionRequiresOpenPeriod': 'Putni nalog kome vožnja pripada mora biti otvoren. Prvo ponovo otvorite putni nalog.',

    // Odometer chain errors
    'Odometer.OutOfChain': 'Kilometraža se ne uklapa između susednih očitavanja vozila (prethodnog i sledećeg).',
    'Odometer.BelowLastReading': 'Kilometraža vozila ne može biti manja od poslednjeg evidentiranog očitavanja. Umesto toga ispravite pogrešno očitavanje.',
    'Odometer.BelowInitialOdometer': 'Kilometraža je manja od početnog stanja vozila, a vozilo još nema očitavanja. Prvo ispravite stanje kilometraže vozila.',

    // Odometer correction errors
    'OdometerCorrection.NotFound': 'Korekcija kilometraže nije pronađena.',
    'OdometerCorrection.InvalidVehicleId': 'ID vozila je obavezan za korekciju kilometraže.',
    'OdometerCorrection.InvalidTargetId': 'Nije navedeno šta se ispravlja (vožnja, putni nalog ili vozilo).',
    'OdometerCorrection.InvalidFieldForTarget': 'Izabrano polje kilometraže ne odgovara vrsti zapisa koji se ispravlja.',
    'OdometerCorrection.InvalidValue': 'Kilometraža mora biti nenegativna vrednost.',
    'OdometerCorrection.ReasonRequired': 'Razlog korekcije kilometraže je obavezan.',
    'OdometerCorrection.CorrectedByRequired': 'Nije poznato ko vrši korekciju kilometraže.',
    'OdometerCorrection.OnlyVehicleCorrectionsCanBeVoided': 'Mogu se stornirati samo ručne korekcije vozila. Kilometraža vožnje ili putnog naloga ispravlja se novom ispravkom.',
    'OdometerCorrection.AlreadyVoided': 'Korekcija kilometraže je već stornirana.',
    'OdometerCorrection.VoidReasonRequired': 'Razlog storniranja je obavezan.',
    'OdometerCorrection.InvalidTargetType': 'Nevažeća vrsta zapisa za korekciju kilometraže.',

    // Work Order errors
    'WorkOrder.NotAuthorizedForType': 'Nemate dozvolu za ovaj tip radnog naloga.',

    // Operation Record errors
    'OperationRecord.NotAuthorizedForType': 'Nemate dozvolu za ovaj tip troška.',

    // Vehicle errors
    'Vehicle.NotFound': 'Vozilo nije pronađeno.',
    'Vehicle.InvalidBrand': 'Marka vozila je obavezna.',
    'Vehicle.InvalidModel': 'Model vozila je obavezan.',
    'Vehicle.InvalidPlateNumber': 'Registarska oznaka vozila je obavezna.',
    'Vehicle.PlateNumberAlreadyExists': 'Vozilo sa ovom registarskom oznakom već postoji.',
    'Vehicle.InvalidOdometerReading': 'Stanje kilometraže mora biti pozitivna vrednost.',
    'Vehicle.InvalidPassengerSeats': 'Broj putničkih sedišta mora biti pozitivna vrednost.',
    'Vehicle.InvalidRegistrationDates': 'Datum isteka registracije mora biti nakon datuma registracije.',
    'Vehicle.InvalidFleetUserId': 'ID korisnika voznog parka je obavezan za dodelu vozača.',
    'Vehicle.InvalidFleetUserName': 'Ime korisnika voznog parka je obavezno za dodelu vozača.',
    'Vehicle.NoActiveAssignment': 'Nije pronađena aktivna dodela vozača za ovo vozilo.',
    'Vehicle.InvalidExpectedEndDate': 'Očekivani datum završetka mora biti u budućnosti za dugoročne dodele.',
    'Vehicle.ExpectedEndDateRequiredForLongTerm': 'Očekivani datum završetka je obavezan za dugoročne dodele.',
    'Vehicle.InvalidAssignmentType': 'Nevažeći tip dodele. Mora biti Privremena, Dugoročna ili Stalna.',
    'Vehicle.AlreadyArchived': 'Vozilo je već arhivirano.',
    'Vehicle.CannotArchiveInUse': 'Vozilo ne može biti arhivirano dok je u upotrebi.',
    'Vehicle.InvalidDescription': 'Opis je obavezan.',
    'Vehicle.InvalidCost': 'Trošak mora biti veći od nule.',
    'Vehicle.NotFree': 'Vozilo nije u validnom statusu za ovu operaciju.',
    'Vehicle.NotReserved': 'Vozilo ne može biti označeno kao u upotrebi u trenutnom statusu.',
    'Vehicle.Disposed': 'Vozilo je prodato ili rashodovano i ne može promeniti status.',
    'Vehicle.NotAvailable': 'Vozilo nije dostupno za traženi period.',
    'Vehicle.AlreadyRegistered': 'Vozilo je već registrovano. Koristite obnovu registracije.',
    'Vehicle.NotRegistered': 'Vozilo nije registrovano. Nije moguće obnoviti registraciju za neregistrovano vozilo.',
    'Vehicle.InvalidRegistrationNumber': 'Broj saobraćajne nije ispravan.',
    'Vehicle.OverlappingRegistration': 'Registracija već postoji za ovo vozilo u navedenom periodu.',
    'Vehicle.CannotChangeDriverWithActiveTravelOrders': 'Nije moguće promeniti dodelu vozača dok je vožnja u toku.',
    'Vehicle.BlockNotFound': 'Blokada vozila nije pronađena.',
    'Vehicle.InvalidBlockReason': 'Razlog blokade je obavezan.',
    'Vehicle.InvalidBlockDates': 'Datum završetka blokade mora biti nakon datuma početka.',
    'Vehicle.OverlappingBlock': 'Blokada već postoji za ovo vozilo u navedenom periodu.',
    'Vehicle.BlockAlreadyClosed': 'Ova blokada je već zatvorena.',
    'Vehicle.CannotArchiveWithActiveBlocks': 'Vozilo ne može biti arhivirano dok ima aktivne blokade.',
    'Vehicle.HasOverlappingTravelOrder': 'Vozilo ima odobrenu(aktivnu) vožnju u traženom periodu.',
    'Vehicle.HasOverlappingBlock': 'Vozilo je blokirano u traženom periodu.',
    'Vehicle.TransferToSameUnit': 'Vozilo već pripada izabranoj jedinici.',
    'Vehicle.TransferDateBeforeLastTransfer': 'Datum premeštaja ne može biti pre poslednjeg evidentiranog premeštaja.',
    'Vehicle.OperationalUnitChangeRequiresTransfer': 'Jedinica se ne može menjati izmenom vozila. Koristite premeštaj vozila.',
    'Vehicle.CannotTransferWithTripInProgress': 'Vozilo se ne može premestiti dok je vožnja u toku. Prvo završite vožnju.',
    'Vehicle.CannotTransferNotAuthorized': 'Nemate ovlašćenje da premeštate vozila između ovih jedinica.',
    'Vehicle.NotAuthorizedForUnit': 'Nemate ovlašćenje nad jedinicom ovog vozila.',
    'FuelLog.NotAuthorizedForUnit': 'Unos goriva može menjati ili brisati samo menadžer za jedinicu vozila.',
    'FuelProduct.SkuAlreadyExists': 'Proizvod sa tom šifrom već postoji u katalogu.',
    'FuelProduct.InvalidSku': 'Šifra proizvoda je obavezna.',
    'FuelProduct.InvalidName': 'Naziv proizvoda je obavezan.',
    'FuelProduct.FuelTypeRequired': 'Gorivo mora imati tip goriva.',
    'FuelProduct.FuelTypeNotAllowed': 'Tip goriva se upisuje samo za gorivo.',
    'FuelProduct.NotFound': 'Proizvod nije pronađen.',
    'FuelLog.NotFound': 'Unos goriva nije pronađen.',
    'FuelLog.InvalidQuantity': 'Količina mora biti veća od nule.',
    'FuelLog.InvalidTotalCost': 'Ukupan trošak mora biti veći od nule.',
    'FuelLog.InvalidOdometerReading': 'Kilometraža ne može biti negativna.',
    'FuelLog.InvalidProductName': 'Naziv proizvoda je obavezan.',
    'FuelLog.InvalidProductType': 'Tip proizvoda nije ispravan.',
    'FuelLog.InvalidUnit': 'Jedinica mere nije ispravna.',
    'FuelLog.InvalidFuelType': 'Tip goriva nije ispravan.',
    'FuelLog.FuelMustHaveFuelType': 'Gorivo mora imati tip goriva.',
    'FuelLog.AdBlueCannotHaveFuelType': 'Tip goriva se upisuje samo za gorivo.',
    'FuelLog.DateOutsidePeriodRange': 'Datum sipanja mora biti unutar perioda putnog naloga.',
    'FuelLog.CannotAddToCancelledPeriod': 'Gorivo se ne može dodati na otkazan putni nalog.',
    'FuelLog.CannotModifyFuturePeriod': 'Gorivo se ne može dodati na putni nalog koji još nije počeo.',
    'FuelLogImport.InvalidFile': 'Fajl nije ispravan NIS Excel izveštaj. Proverite format i list „Izvestaj".',
    'FuelLogImport.OdometerRequired': 'Svaki red mora imati kilometražu pre uvoza.',
    'FuelProduct.InvalidProductType': 'Tip proizvoda nije ispravan.',
    'FuelProduct.InvalidFuelType': 'Tip goriva nije ispravan.',
    'FuelProduct.InvalidUnit': 'Jedinica mere nije ispravna.',
    'Vehicle.InvalidOperationalUnitId': 'Jedinica je obavezna.',
    'Vehicle.InvalidInternalCode': 'Interni broj vozila je obavezan.',
    'Vehicle.InvalidReferenceConsumption': 'Referentna potrošnja mora biti veća od nule.',
    'Vehicle.InvalidConsumptionTolerance': 'Tolerancija potrošnje mora biti između 0 i 100 procenata.',
    'Vehicle.NotInRequestPool': 'Vozilo nije dostupno za zahteve.',
    'Vehicle.RegistrationExpiredForPeriod': 'Registracija vozila ne važi za traženi period. Obnovite registraciju pre podnošenja zahteva.',

    // Operational Unit errors
    'OperationalUnit.InvalidId': 'Jedinica je obavezna.',
    'OperationalUnit.InvalidName': 'Naziv jedinice je obavezan.',
    'OperationalUnit.InvalidSapCode': 'SAP šifra je obavezna.',
    'OperationalUnit.InvalidCityPrefix': 'Prefiks grada je obavezan.',
    'OperationalUnit.MissingCityPrefix': 'Jedinica nema podešen prefiks grada, pa nije moguće dodeliti interni broj vozila.',
    'OperationalUnit.AlreadyArchived': 'Jedinica je već arhivirana.',
    'OperationalUnit.NotArchived': 'Jedinica nije arhivirana.',
    'OperationalUnit.DuplicateSapCode': 'Jedinica sa ovom SAP šifrom već postoji.',
    'OperationalUnit.NotFound': 'Jedinica nije pronađena.',

    // Fleet User errors
    'FleetUser.NotFound': 'Korisnik voznog parka nije pronađen.',

    // HR Catalog errors
    'EducationQualificationCatalog.LevelAndTypeConflict': 'NOKS kvalifikacija sa unetom šifrom nivoa i vrstom već postoji.',
    'EducationQualificationCatalog.NoksDisplayDoesNotMatchLevel': 'Prikaz NOKS mora početi vrednošću iz polja NOKS nivo.',

    // Employee document errors
    'EmployeeDocument.CannotUploadFinal': 'Konačni dokument se može dodati samo dok je dokument u statusu nacrta.',
    'EmployeeDocument.CannotRegenerate': 'Nacrt se može regenerisati samo dok je dokument još uvek nacrt.',
    'EmployeeDocument.CannotReplaceFinal': 'Konačni dokument se može zameniti samo pre nego što bude arhiviran.',
    'EmployeeDocument.CannotHardDelete': 'Dokument se može obrisati samo dok nije u arhivi (nikad poslat ili neuspeo pokušaj). Otkažite dokumente koji se šalju ili su već arhivirani.',
    'EmployeeDocument.CannotUpdateMetadata': 'Podaci se ne mogu menjati za arhivirane ili otkazane dokumente.',
    'EmployeeDocument.InvalidFinalFile': 'Fajl konačnog dokumenta nije ispravan.',

    // Document template errors
    'DocumentTemplate.CannotDeleteUsed': 'Šablon je već korišćen za generisanje dokumenata i ne može se obrisati. Umesto brisanja ga deaktivirajte.',

    // Generic fallback
    default: 'Došlo je do greške. Pokušajte ponovo.',
  },
  tireTracking: {
    nav: 'Evidencija guma',
    title: 'Gume',
    addNew: 'Nova guma',
    searchPlaceholder: 'Pretraži po marki, dimenziji, vozilu...',
    statusFilterLabel: 'Status',
    seasonFilterLabel: 'Sezona',
    allStatuses: 'Svi statusi',
    allSeasons: 'Sve tipove',
    totalCount: 'Ukupno: {{count}} guma',
    errorLoading: 'Greška pri učitavanju guma.',
    emptyMessage: 'Nema guma za prikaz.',
    emptyMessageFiltered: 'Nema guma koje odgovaraju filterima.',
    status: {
      InStorage: 'Na skladištu',
      InUse: 'U upotrebi',
      Disposed: 'Otpisana',
    },
    season: {
      Summer: 'Letnja',
      Winter: 'Zimska',
      AllSeason: 'Sve sezone',
    },
    position: {
      FrontLeft: 'Prednja leva',
      FrontRight: 'Prednja desna',
      RearLeft: 'Zadnja leva',
      RearRight: 'Zadnja desna',
      RearLeftOuter: 'Zadnja leva spoljna',
      RearLeftInner: 'Zadnja leva unutrašnja',
      RearRightOuter: 'Zadnja desna spoljna',
      RearRightInner: 'Zadnja desna unutrašnja',
      Spare: 'Rezervna',
    },
    columns: {
      inventoryNumber: 'Inv. broj',
      brandModel: 'Marka / Model',
      dimension: 'Dimenzija',
      type: 'Tip',
      status: 'Status',
      vehicle: 'Vozilo',
      position: 'Pozicija',
      dot: 'DOT',
      actions: 'Akcije',
    },
    tooltips: {
      view: 'Prikaži detalje',
      edit: 'Izmeni podatke gume',
      mount: 'Montiraj na vozilo',
      unmount: 'Skini s vozila',
      editMileage: 'Izmeni početni km',
      dispose: 'Otpiši',
      reactivate: 'Vrati u skladište',
      delete: 'Obriši',
    },
    fields: {
      brand: 'Marka',
      model: 'Model',
      dimension: 'Dimenzija',
      dimensionHint: 'Dimenzija (npr. 205/55 R16)',
      seasonType: 'Tip sezone',
      dotCode: 'DOT kod',
      purchaseDate: 'Datum kupovine',
      notes: 'Napomena',
      position: 'Pozicija',
      mountDate: 'Datum montaže',
      unmountDate: 'Datum skidanja',
      mileageAtInstall: 'Kilometraža pri montaži',
      mileageAtInstallLabel: 'Kilometraža pri montaži (km)',
      mileageAtRemoval: 'Kilometraža pri skidanju',
      optional: 'Opciono',
      vehicle: 'Vozilo',
      tireFromStorage: 'Guma iz skladišta',
      noTiresInStorage: 'Nema guma u skladištu',
    },
    validation: {
      brandRequired: 'Marka je obavezna',
      dimensionRequired: 'Dimenzija je obavezna',
      mountDateRequired: 'Datum montaže je obavezan',
      unmountDateRequired: 'Datum skidanja je obavezan',
      mileagePositive: 'Kilometraža mora biti pozitivna',
      tireRequired: 'Odabir gume je obavezan',
      quantityMin: 'Količina mora biti najmanje 1',
      quantityMax: 'Količina ne može biti veća od {{max}}',
      dotCodesCountMismatch: 'Broj DOT kodova ({{actual}}) mora odgovarati količini ({{expected}})',
      dotCodeTooLong: 'DOT kod ne može imati više od 20 karaktera',
    },
    create: {
      title: 'Nova guma',
      submit: 'Kreiraj',
      submitting: 'Kreiranje...',
      error: 'Greška prilikom kreiranja gume',
      cancel: 'Otkaži',
      quantity: 'Količina',
      quantityHelper: 'Unesite 1 za jednu gumu, ili više za grupni unos (max {{max}})',
      dotCodesMode: 'DOT kodovi',
      dotCodesModeNone: 'Bez DOT kodova',
      dotCodesModeNoneHelper: 'Sve gume biće kreirane bez DOT koda. Možete ih dodati kasnije pojedinačno.',
      dotCodesModeList: 'Nalepi listu DOT kodova',
      dotCodesListLabel: 'DOT kodovi (jedan po redu)',
      dotCodesListHelper: '{{entered}} / {{expected}} kodova',
      bulkSubmit: 'Kreiraj {{count}} guma',
    },
    edit: {
      title: 'Izmena gume',
      submit: 'Sačuvaj',
      submitting: 'Čuvanje...',
      error: 'Greška prilikom izmene gume',
      cancel: 'Otkaži',
    },
    detail: {
      title: 'Detalji gume',
      inventoryNumber: 'Inventarski broj',
      brand: 'Marka',
      model: 'Model',
      dimension: 'Dimenzija',
      seasonType: 'Tip sezone',
      dotCode: 'DOT kod',
      purchaseDate: 'Datum nabavke',
      status: 'Status',
      vehicle: 'Vozilo',
      position: 'Pozicija',
      notes: 'Napomena',
      assignmentHistory: 'Istorija montaže',
      neverMounted: 'Guma nije bila montirana.',
      active: 'Aktivna',
      table: {
        vehicle: 'Vozilo',
        position: 'Pozicija',
        installed: 'Montirano',
        removed: 'Skinuto',
        mileageAtInstall: 'km pri montaži',
        mileageAtRemoval: 'km pri skidanju',
      },
    },
    unmount: {
      title: 'Skini gumu s vozila',
      submit: 'Skini gumu',
      submitting: 'Skidanje...',
      error: 'Greška prilikom skidanja gume',
      cancel: 'Otkaži',
    },
    dispose: {
      title: 'Otpiši gumu',
      confirm: 'Da li ste sigurni da želite da otpišete gumu {{tire}}? Guma će biti označena kao otpisana. Istorija montaže ostaje sačuvana.',
      submit: 'Otpiši',
      submitting: 'Otpisivanje...',
      error: 'Greška prilikom otpisa gume',
      cancel: 'Otkaži',
    },
    reactivate: {
      title: 'Vrati gumu u skladište',
      confirm: 'Da li ste sigurni da želite da vratite gumu {{tire}} u skladište? Status gume će biti promenjen iz "Otpisana" u "Na skladištu".',
      submit: 'Vrati u skladište',
      submitting: 'Vraćanje...',
      error: 'Greška prilikom reaktivacije gume',
      cancel: 'Otkaži',
    },
    editMileage: {
      title: 'Izmeni početnu kilometražu',
      tireInfo: 'Guma: {{info}}',
      submit: 'Sačuvaj',
      submitting: 'Čuvanje...',
      error: 'Greška prilikom izmene kilometraže',
      cancel: 'Otkaži',
    },
    mount: {
      title: 'Montiraj gumu',
      submit: 'Montiraj',
      submitting: 'Montaža...',
      error: 'Greška prilikom montaže gume',
      cancel: 'Otkaži',
    },
    mountToVehicle: {
      title: 'Montiraj gumu na vozilo',
      vehicleLabel: 'Vozilo:',
      submit: 'Montiraj',
      submitting: 'Montaža...',
      error: 'Greška prilikom montaže gume',
      cancel: 'Otkaži',
    },
    registerAndMount: {
      title: 'Dodaj novu gumu na vozilo',
      vehicleLabel: 'Vozilo:',
      tireInfoSection: 'Podaci o gumi',
      mountSection: 'Montaža',
      submit: 'Dodaj i montiraj',
      submitting: 'Dodavanje...',
      error: 'Greška prilikom dodavanja gume',
      cancel: 'Otkaži',
    },
  },
  footer: {
    allRightsReserved: 'Sva prava zadržana.',
    support: 'Podrška',
    privacyPolicy: 'Politika privatnosti',
    termsOfUse: 'Uslovi korišćenja',
  },
} as const;
